<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">
        {{ $t("edit") }} {{ $t("promotionsandoffer") }}
      </div>
      <router-link class="btn-blue" to="promotions-and-offers"
        >{{ $t("promotionsandoffer") }} {{ $tc("list") }}</router-link
      >
    </div>
    <div class="white-wrapper">
      <section class="mb-2">
        <div class="d-flex">
          <div
            class="
              section-title
              mb-2
              d-flex
              justify-content-between
              section-border section-border
              col-11
            "
            style="padding: 6px; align-items: center"
            v-b-toggle.offer
          >
            <span class="fs">Offer</span>
            <button type="button" class="btn-transparent chevron">
              <img
                src="@/assets/img/icons/primary/chevron-down.svg"
                height="24"
                width="24"
              />
            </button>
          </div>
          <div class="col-1 align-self-center">
            <div class="d-flex align-items-center">
              <b-form-checkbox
                v-model="OffersAndPromotion.os_is_active"
                name="check-button"
                class="j-checkbox pb-0"
              ></b-form-checkbox>
              <label class="mb-0 mr-2">{{ $t("active") }}</label>
            </div>
          </div>
        </div>

        <b-collapse id="offer" v-model="sectionCollapse.offer">
          <div class="new-border rounded-10 back pt-3 pb-0 pl-3 pr-3 mb-2">
            <div class="row">
              <div class="back_white px-0 mx-3 pt-2 mb-3">
                <div class="d-flex">
                  <div class="col-lg-4 col-xl-2 mb-2">
                    <div class="input-material">
                      <input
                        v-model="OffersAndPromotion.offer_title"
                        placeholder="."
                        type="text"
                        name="offer_title"
                        id="offer_title"
                        v-validate="'required'"
                        @input="onChangeText($event, 'name')"
                      />
                      <label>{{ $t("title") }}</label>
                    </div>
                    <p
                      v-if="submitted && errors.has('offer_title')"
                      class="error_message"
                    >
                      <span>{{ errors.first("offer_title") }}</span>
                    </p>
                  </div>
                  <div class="col-lg-4 col-xl-2 mb-2">
                    <div class="input-material">
                      <input
                        disabled
                        v-model="OffersAndPromotion.offer_code"
                        placeholder="."
                        type="text"
                      />
                      <label>{{ $t("code") }}</label>
                    </div>
                  </div>

                  <!-- {{ OffersAndPromotion.offer_start_date_time }} -->
                  <div class="col-lg-4 col-xl-2 mb-2">
                    <div class="input-material">
                      <div class="add-datepicker custom-date">
                        <button
                          class="btn-clearDate"
                          style="right: 13px !important"
                          v-if="OffersAndPromotion.offer_start_date_time"
                          v-on:click="
                            OffersAndPromotion.offer_start_date_time = null
                          "
                        >
                          ✖
                        </button>
                        <div
                          class="
                            d-flex
                            justify-content-center
                            align-items-center
                          "
                        >
                          <Datepicker
                            :monday-first="true"
                            ref="programaticOpen"
                            v-model="OffersAndPromotion.offer_start_date_time"
                            type="date"
                            class="theme-custom-date-time"
                            typeable
                            v-validate="'required'"
                            v-b-tooltip.hover
                            :title="$t('offer_start_date_tooltip')"
                          ></Datepicker>
                          <!--Tooltip :title="$t('offer_start_date_tooltip')" /-->
                        </div>
                        <label
                          :class="
                            OffersAndPromotion.offer_start_date_time
                              ? 'active'
                              : ''
                          "
                          >{{ $t("startdate") }}</label
                        >
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-xl-2 mb-2">
                    <div class="input-material">
                      <div class="add-datepicker custom-date">
                        <button
                          style="right: 13px !important"
                          class="btn-clearDate"
                          v-if="OffersAndPromotion.offer_end_date_time"
                          v-on:click="
                            OffersAndPromotion.offer_end_date_time = null
                          "
                        >
                          ✖
                        </button>
                        <div
                          class="
                            d-flex
                            justify-content-center
                            align-items-center
                          "
                        >
                          <Datepicker
                            :monday-first="true"
                            ref="programaticOpen"
                            v-model="OffersAndPromotion.offer_end_date_time"
                            type="date"
                            class="theme-custom-date-time"
                            typeable
                            v-validate="'required'"
                            v-b-tooltip.hover
                            :title="$t('offer_end_date_tooltip')"
                          ></Datepicker>
                          <!--Tooltip :title="$t('offer_end_date_tooltip')" /-->
                        </div>
                        <label
                          :class="
                            OffersAndPromotion.offer_end_date_time
                              ? 'active'
                              : ''
                          "
                          >{{ $t("enddate") }}</label
                        >
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-xl-2 mb-2 custom-timepicker">
                    <div
                      class="d-flex justify-content-center align-items-center"
                    >
                      <vue-timepicker
                        manual-input
                        v-model="OffersAndPromotion.startTime2"
                        id="starttime"
                        name="starttime"
                        :placeholder="$tc('starttime')"
                        format="HH:mm"
                        class="time_picker"
                        input-width="100%"
                        auto-scroll
                        lazy
                        v-b-tooltip.hover
                        :title="$t('offer_start_time')"
                      ></vue-timepicker>
                      <!--Tooltip :title="$t('offer_start_time')" /-->
                    </div>
                    <!-- <div class="input-material">
              <div class="add-datepicker">
                <date-picker
                  v-model="OffersAndPromotion.offer_start_date_time"
                  type="time"
                  class="theme-custom-date-time"
                  format="hh:mm a"
                  use12-hour
                  lang="en"
                  :minute-step="1"
                  typeable
                  v-validate="'required'"
                  id="o_start_time"
                ></date-picker>
                <label class="active"
                  >{{ $t("offer") }} {{ $t("starttime") }}</label
                >
              </div>
            </div> -->
                  </div>

                  <div class="col-lg-4 col-xl-2 mb-2 custom-timepicker">
                    <div
                      class="d-flex justify-content-center align-items-center"
                    >
                      <vue-timepicker
                        manual-input
                        v-model="OffersAndPromotion.endTime2"
                        id="endtime"
                        name="endtime"
                        :placeholder="$tc('endtime')"
                        format="HH:mm"
                        class="time_picker"
                        input-width="100%"
                        auto-scroll
                        lazy
                        v-b-tooltip.hover
                        :title="$t('offer_end_time')"
                      ></vue-timepicker>
                      <!--Tooltip :title="$t('offer_end_time')" /-->
                    </div>
                    <!-- <div class="input-material">
              <div class="add-datepicker">
                <date-picker
                  v-model="OffersAndPromotion.offer_end_date_time"
                  type="time"
                  class="theme-custom-date-time"
                  format="hh:mm a"
                  use12-hour
                  lang="en"
                  :minute-step="1"
                  typeable
                  v-validate="'required'"
                  id="o_end_time"
                ></date-picker>
                <label class="active"
                  >{{ $t("offer") }} {{ $t("endtime") }}</label
                >
              </div>
            </div> -->
                  </div>
                  <!-- client_id -->
                  <!-- <div class="col-lg-6 col-xl-3 mb-4">
            <multiselect
              v-model="OffersAndPromotion.selectedClient"
              placeholder="Select Client"
              :options="clientList"
              @select="onSelectClient($event)"
              label="client_name"
              track-by="client_id"
              :multiple="false"
            ></multiselect>
          </div>-->
                </div>
              </div>

              <section class="mb-2 col-lg-12 col-xl-12 align-self-center">
                <div class="bn-tabs-nav mb-2">
                  <button
                    v-for="(Content, ContentIndex) in offerContent"
                    :key="ContentIndex"
                    :class="[
                      'btn-tab-title ',
                      { active: ContentIndex == activeClass },
                    ]"
                    @click.prevent.stop="
                      onChangeTabHandler($event, ContentIndex)
                    "
                  >
                    <strong>
                      <span
                        :class="
                          Content.langauge.toLowerCase() !== 'english'
                            ? notempty[ContentIndex]
                              ? ''
                              : 'text-danger'
                            : ''
                        "
                        >{{ Content.langauge }}</span
                      >
                    </strong>
                  </button>
                </div>
                <div class="bn-tabs-content">
                  <div
                    v-for="(Content, ContentIndex) in offerContent"
                    :key="ContentIndex"
                  >
                    <div v-if="ContentIndex === activeClass">
                      <div class="row">
                        <div class="col-lg-6 col-xl-4 align-self-center">
                          <div class="d-flex align-items-center">
                            <div class="input-material">
                              <input
                                placeholder="."
                                type="text"
                                v-model="Content.offer_title"
                                name="offer_content_title"
                                id="offer_content_title"
                                @input="
                                  CheckEmptyContent(Content, ContentIndex)
                                "
                                v-validate="
                                  Content.langauge.toLowerCase() === 'english'
                                    ? 'required'
                                    : ''
                                "
                                v-b-tooltip.hover
                                :title="$t('offer_content_title')"
                              />
                              <label
                                >{{ $t("offer") }} {{ $t("title") }} ({{
                                  $t("optional")
                                }})</label
                              >
                            </div>
                            <!--Tooltip :title="$t('offer_content_title')" /-->
                          </div>
                          <p class="error_message">
                            <span
                              v-if="
                                submitted && errors.has('offer_content_title')
                              "
                              >{{ errors.first("offer_content_title") }}</span
                            >
                          </p>
                          <!--p
                        v-if="Content.langauge.toLowerCase() !== 'english'"
                        class="fs-12"
                      >
                        ({{ $t("optional") }})
                      </p-->
                        </div>

                        <div
                          class="col-lg-6 col-xl-6 align-self-center"
                          v-if="false"
                        >
                          <div class="d-flex align-items-center">
                            <div class="input-material">
                              <input
                                placeholder="."
                                type="text"
                                v-model="Content.offer_description"
                                name="offer_content_desc"
                                id="offer_content_desc"
                                @input="
                                  CheckEmptyContent(Content, ContentIndex)
                                "
                                v-b-tooltip.hover
                                :title="$t('offer_content_desc')"
                              />
                              <label
                                >{{ $t("description") }} ({{
                                  $t("optional")
                                }})</label
                              >
                            </div>
                            <!--Tooltip :title="$t('offer_content_desc')" /-->
                          </div>
                          <p class="error_message">
                            <span v-if="submitted && errors.has('offerdesc')">{{
                              errors.first("offerdesc")
                            }}</span>
                          </p>
                          <!--p
                        v-if="Content.langauge.toLowerCase() !== 'english'"
                        class="fs-12"
                      >
                        ({{ $t("optional") }})
                      </p-->
                        </div>

                        <div class="col-lg-6 col-xl-4 align-self-center mb-3">
                          <div class="row align-self-center">
                            <div class="col-10">
                              <label
                                class="material-file-upload"
                                @click.prevent.stop="
                                  setModalData(
                                    banner_image_height,
                                    banner_image_width,
                                    ContentIndex,
                                    1
                                  )
                                "
                              >
                                <div class="label"></div>
                                <div class="uploaded-file-name">
                                  <div class="text-truncate">
                                    {{
                                      Content.offer_banner_image
                                        ? Content.offer_banner_image
                                        : "Offer Banner Image"
                                    }}
                                  </div>
                                </div>
                              </label>
                            </div>
                            <div class="col-1 mt-1">
                              <img
                                width="40"
                                height="40"
                                class="rounded c-pointer img-preview"
                                @click="
                                  openImageModal('', Content.offer_banner_image)
                                "
                                :src="_GetImagePath(Content.offer_banner_image)"
                                v-if="Content.offer_banner_image"
                              />
                              <img
                                v-else
                                width="35"
                                height="35"
                                class="rounded"
                                alt="Empty Image"
                                src="@/assets/img/icons/empty-image.svg"
                              />
                            </div>
                          </div>
                        </div>
                        <div class="col-lg-6 col-xl-4 align-self-center mb-3">
                          <div class="row align-self-center">
                            <div class="col-10">
                              <label
                                class="material-file-upload"
                                @click.prevent.stop="
                                  setModalData(
                                    poster_image_height,
                                    poster_image_width,
                                    ContentIndex,
                                    2
                                  )
                                "
                              >
                                <div class="label"></div>
                                <div class="uploaded-file-name">
                                  <div class="text-truncate">
                                    {{
                                      Content.offer_poster_image
                                        ? Content.offer_poster_image
                                        : "Offer Poster Image"
                                    }}
                                  </div>
                                </div>
                              </label>
                            </div>
                            <div class="col-1 mt-1">
                              <img
                                width="40"
                                height="40"
                                class="rounded c-pointer img-preview"
                                @click="
                                  openImageModal('', Content.offer_poster_image)
                                "
                                :src="_GetImagePath(Content.offer_poster_image)"
                                v-if="Content.offer_poster_image"
                              />
                              <img
                                v-else
                                width="35"
                                height="35"
                                class="rounded"
                                alt="Empty Image"
                                src="@/assets/img/icons/empty-image.svg"
                              />
                            </div>
                          </div>
                        </div>

                        <div
                          class="
                            col-lg-12
                            align-self-center
                            mb-4
                            descriptionEditor
                          "
                        >
                          <div
                            class="
                              descriptionSection
                              font-weight-bold
                              fs-14
                              mb-3
                            "
                          >
                            Description
                          </div>
                          <div class="" v-if="isEdit">
                            <vue-editor
                              v-model="Content.offer_description"
                              name="page"
                              id="page"
                            ></vue-editor>
                          </div>
                          <div
                            class="input-material-textarea"
                            v-else-if="isEditHtml && !isEdit"
                          >
                            <textarea
                              id="htmlContent"
                              name="htmlContent"
                              @input="
                                onChangeTranslationInput(
                                  $event,
                                  Content,
                                  ContentIndex,
                                  'offer_description'
                                )
                              "
                              v-model="Content.offer_description"
                              placeholder="Description"
                              class="htmlContent"
                            />
                          </div>
                          <div class="ql-snow" v-else>
                            <div
                              class="ql-editor"
                              v-html="Content.offer_description"
                              v-if="Content.offer_description"
                            ></div>
                            <div
                              class="ql-editor text-center"
                              v-else
                              style="min-height: 33px"
                            >
                              No Content
                            </div>
                          </div>
                          <vue-editor style="display: none" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </b-collapse>
      </section>

      <section class="mb-2">
        <div
          class="
            section-title
            mb-3
            d-flex
            justify-content-between
            section-border section-border
          "
          style="padding: 6px; align-items: center"
          v-b-toggle.offerconfig
        >
          <span class="fs">{{ $t("offerconfiguration") }}</span>
          <button type="button" class="btn-transparent chevron">
            <img
              src="@/assets/img/icons/primary/chevron-down.svg"
              height="24"
              width="24"
            />
          </button>
        </div>
        <b-collapse id="offerconfig" v-model="sectionCollapse.offerconfig">
          <div class="new-border rounded-10 pt-3 px-3 pb-0 mb-2 back">
            <!--div class="section-title text-uppercase mb-2" style="font-size: 20px">
          {{ $t("offerconfiguration") }}
        </div-->
            <ul class="select-offers-list">
              <li style="padiing-bottom: 6px">
                <div class="d-flex align-self-center">
                  <strong>1.&nbsp;</strong>
                  <b-form-checkbox
                    class="ml-3 pb-0 j-checkbox"
                    v-model="OfferConfiguraion.offer_applicable_on_all_cinemas"
                    unchecked-value="N"
                    value="Y"
                  ></b-form-checkbox>
                  <div>
                    {{ $t("applicableforselectedcinemasclassesntickettypes") }}
                  </div>
                </div>
                <b-collapse
                  id
                  v-model="
                    OfferConfiguraion.offer_applicable_on_all_cinemas === 'Y'
                  "
                >
                  <div class="px-0 pt-2">
                    <div
                      v-for="(
                        Item, ItemsIndex
                      ) in selectedCinemaScreenSeatClassList"
                      :key="ItemsIndex"
                      class="row back_white mb-2 pt-2 mx-1"
                    >
                      <div class="col-lg-6 col-xl-3 mb-lg-2 mb-xl-0">
                        <div class="multiselect-sm">
                          <!-- v-model="OfferConfiguraion.cine_id" -->
                          <!-- @input="getScreenList" -->

                          <custommultiselect
                            v-model="Item.cine_id"
                            :options="cinemasList"
                            @input="getScreenList($event, ItemsIndex)"
                            :placeholder="$tc('selectCinemas')"
                            label="cine_name"
                            isSingleId="cine_id"
                            :multiple="false"
                            track-by="cine_id"
                          ></custommultiselect>
                        </div>
                      </div>
                      <div class="col-lg-6 col-xl-2 mb-lg-2 mb-xl-0">
                        <div class="multiselect-sm">
                          <custommultiselect
                            v-model="Item.screen_id"
                            :options="
                              CinemasScreenSeatClassdataList[ItemsIndex]
                                .screenList
                            "
                            @input="getSeatClassList($event, ItemsIndex)"
                            :placeholder="$tc('screens')"
                            label="screen_name"
                            isSingleId="screen_id"
                            :multiple="false"
                            track-by="screen_id"
                          ></custommultiselect>
                        </div>
                      </div>

                      <div class="col-lg-6 col-xl-3 mb-xl-0">
                        <div class="multiselect-sm">
                          <custommultiselect
                            v-model="Item.sst_id"
                            :options="
                              CinemasScreenSeatClassdataList[ItemsIndex]
                                .seatClassList
                            "
                            :placeholder="$tc('Seat Class')"
                            label="sst_seat_type"
                            isSingleId="sst_id"
                            :multiple="false"
                            track-by="sst_id"
                          ></custommultiselect>
                        </div>
                      </div>
                      <!-- SELECT TICKET TYPE -->
                      <div
                        class="
                          col-md-4 col-xl-3
                          mb-md-4 mb-xl-0
                          mt-md-3 mt-xl-0
                        "
                      >
                        <div class="d-flex align-items-center">
                          <custommultiselect
                            v-model="Item.tt_id"
                            :options="TicketTypes"
                            label="tt_name"
                            track-by="tt_id"
                            :placeholder="$tc('Ticket Type')"
                            :multiple="false"
                            v-b-tooltip.hover
                            :title="$tc('selectTicketType')"
                          />
                          <!--Tooltip :title="$tc('selectTicketType')" /-->
                        </div>
                      </div>
                      <!-- SELECT TICKET TYPE -->
                      <div class="col-lg-3 col-xl-1 mb-xl-0 mt-3 mt-lg-0">
                        <button
                          v-if="ItemsIndex == 0"
                          class="btn-transparent mb-3"
                          @click="addMoreCinemasScreenSeatClass()"
                        >
                          <img
                            src="@/assets/img/icons/plus.svg"
                            height="35"
                            width="35"
                          />
                        </button>

                        <button
                          v-if="
                            ItemsIndex === 0 &&
                            selectedCinemaScreenSeatClassList.length !== 1 &&
                            false
                          "
                          class="btn-transparent mb-3"
                          @click="removeCinemasScreenSeatClass(ItemsIndex)"
                        >
                          <img
                            src="@/assets/img/icons/minus.svg"
                            height="35"
                            width="35"
                          />
                        </button>

                        <button
                          v-if="ItemsIndex !== 0"
                          class="btn-transparent mb-3"
                          @click="removeCinemasScreenSeatClass(ItemsIndex)"
                        >
                          <img
                            src="@/assets/img/icons/minus.svg"
                            height="35"
                            width="35"
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                </b-collapse>
              </li>
              <li>
                <div class="row mr-2">
                  <div class="col-md-6 align-self-center pt-5">
                    <!-- <label>{{ $t('applicableforparticularmovie') }}</label> -->
                    <div class="multiselect">
                      <custommultiselect
                        v-model="OfferConfiguraion.selectedMovielist"
                        :options="movieList"
                        :placeholder="$t('applicableforparticularmovie')"
                        label="movie"
                        isSingleId="md_id"
                        :multiple="true"
                        track-by="md_id"
                      ></custommultiselect>
                    </div>
                  </div>

                  <div class="col-6 mb-2 back_white py-2">
                    <div class="mb-2">
                      {{ $t("offer_applicable_between_time") }}
                    </div>

                    <div class="d-flex">
                      <div class="col-lg-6 custom-timepicker pl-0">
                        <div
                          class="
                            d-flex
                            justify-content-center
                            align-items-center
                          "
                        >
                          <vue-timepicker
                            manual-input
                            v-model="OfferConfiguraion.pvms_start_show_time"
                            id="o_start_show_time"
                            name="o_start_show_time"
                            :placeholder="$tc('From')"
                            format="HH:mm"
                            class="time_picker"
                            input-width="100%"
                            auto-scroll
                            lazy
                            v-b-tooltip.hover
                            :title="$t('o_start_show_time')"
                          ></vue-timepicker>
                          <!--Tooltip :title="$t('o_start_show_time')" /-->
                        </div>
                        <!-- <div class="input-material">
                  <div class="add-datepicker">
                    <date-picker
                      v-model="OfferConfiguraion.pvms_start_show_time"
                      type="time"
                      class="theme-custom-date-time timepicker"
                      format="hh:mm a"
                      lang="en"
                      :minute-step="1"
                      typeable
                      v-validate="'required'"
                      id="o_start_show_time"
                    ></date-picker>
                    <label class="active"
                      >{{ $t("offer") }} {{ $t("starttime") }}</label
                    >
                  </div>
                </div> -->
                      </div>
                      <div class="col-lg-6 custom-timepicker pl-0">
                        <div
                          class="
                            d-flex
                            justify-content-center
                            align-items-center
                          "
                        >
                          <vue-timepicker
                            manual-input
                            v-model="OfferConfiguraion.pvms_end_show_time"
                            id="o_end_show_time"
                            name="o_end_show_time"
                            :placeholder="$tc('to')"
                            format="HH:mm"
                            class="time_picker"
                            input-width="100%"
                            auto-scroll
                            lazy
                            v-b-tooltip.hover
                            :title="$t('o_end_show_time')"
                          ></vue-timepicker>
                          <!--Tooltip :title="$t('o_end_show_time')" /-->
                        </div>
                        <!-- <div class="input-material">
                  <div class="add-datepicker">
                    <date-picker
                      v-model="OfferConfiguraion.pvms_end_show_time"
                      type="time"
                      class="theme-custom-date-time timepicker"
                      format="hh:mm a"
                      lang="en"
                      :minute-step="1"
                      v-validate="'required'"
                      id="o_end_show_time"
                    ></date-picker>
                    <label class="active"
                      >{{ $t("offer") }} {{ $t("endtime") }}</label
                    >
                  </div>
                </div> -->
                      </div>
                    </div>
                  </div>
                </div>

                <!-- <b-collapse id v-model="OfferConfiguraion.offer_applicable_on_all_movies === 'Y'">
              <div class="p-3">
                <div class="row">
                  <div class="col-lg-6 col-xl-4">
                    <div class="multiselect-sm">
                      <custommultiselect
                        v-model="OfferConfiguraion.md_id"
                        :options="movieList"
                        placeholder="Select Movie"
                        label="movie"
                        isSingleId="md_id"
                        :multiple="false"
                        track-by="md_id"
                      ></custommultiselect>
                    </div>
                  </div>
                </div>
              </div>
            </b-collapse>-->
              </li>

              <li>
                <!-- <div class="d-flex align-self-center">
              <strong>3.&nbsp;</strong>
              <div>{{ $t('applicableforspecificdaysdatetime') }}</div>
              <b-form-checkbox
                class="ml-3"
                v-model="OfferConfiguraion.offer_applicable_on_all_day"
                unchecked-value="N"
                value="Y"
                switch
              ></b-form-checkbox>
            </div>-->
                <!-- <b-collapse id v-model="OfferConfiguraion.offer_applicable_on_all_day === 'Y'"> -->
                <div class="px-3 pt-2">
                  <div class="row">
                    <!-- <div class="col-6 mb-4">
                    <div class="input-material">
                      <div class="add-datepicker">
                        <datetime
                          v-model="OfferConfiguraion.startDateTime"
                          type="datetime"
                          class="theme-custom-date-time"
                          format="yyyy-MM-dd hh:mm:ss a"
                          use12-hour
                        ></datetime>
                        <label
                          class="active"
                        >{{ $t('select') }} {{ $t('startdate') }}&nbsp;&amp;&nbsp;{{ $t('time') }}</label>
                      </div>
                    </div>
                </div>-->

                    <!-- <div class="col-6 mb-4">
                    <div class="input-material">
                      <div class="add-datepicker">
                        <datetime
                          v-model="OfferConfiguraion.endDateTime"
                          type="datetime"
                          class="theme-custom-date-time"
                          format="yyyy-MM-dd hh:mm:ss a"
                          use12-hour
                        ></datetime>
                        <label
                          class="active"
                        >{{ $t('select') }} {{ $t('enddate') }}&nbsp;&amp;&nbsp;{{ $t('time') }}</label>
                      </div>
                    </div>
                </div>-->

                    <div class="col-12">
                      <div class="row">
                        <div class="mb-2">{{ $t("days") }}:</div>
                        <b-form-checkbox
                          v-for="(weekdaysLoop, weekdaysKey) in weekDays"
                          :key="weekdaysKey"
                          class="j-checkbox mx-2 mb-3"
                          @change="onChangeWeekdays($event, weekdaysKey)"
                          v-model="weekDays[weekdaysKey]"
                        >
                          <div class="text-capitalize">{{ weekdaysKey }}</div>
                        </b-form-checkbox>
                      </div>
                    </div>
                    <p class="error_message">
                      <span v-if="submitted && TrueFalseCount == 7"
                        >{{ $t("pleaseSelectAtLeastOneday") }}.</span
                      >
                    </p>
                  </div>
                </div>
                <!-- </b-collapse> -->
              </li>
              <!-- <li>
            <div class="d-flex align-self-center my-3">
              <div>{{ $t("applicableontransactiontime") }}</div>
              <b-form-checkbox
                class="ml-3"
                v-model="OfferConfiguraion.avail_on_advanced_booking"
                unchecked-value="N"
                value="Y"
                switch
              ></b-form-checkbox>
            </div>
          </li> -->
            </ul>
          </div>
        </b-collapse>
      </section>

      <section class="mb-2">
        <div
          class="
            section-title
            mb-3
            d-flex
            justify-content-between
            section-border section-border
          "
          style="padding: 6px; align-items: center"
          v-b-toggle.offersplitconfig
        >
          <span class="fs">
            {{ $t("offer") }} {{ $t("split") }}
            {{ $tc("configuration", 1) }}</span
          >
          <button type="button" class="btn-transparent chevron">
            <img
              src="@/assets/img/icons/primary/chevron-down.svg"
              height="24"
              width="24"
            />
          </button>
        </div>
        <b-collapse
          id="offersplitconfig"
          v-model="sectionCollapse.offersplitconfig"
        >
          <div class="new-border back rounded-10 pt-3 px-3 pb-0 mb-2">
            <!--div class="section-title text-uppercase mb-2" style="font-size: 20px">
          {{ $t("offer") }} {{ $t("split") }} {{ $tc("configuration", 1) }}
        </div-->

            <!-- client_id -->
            <div class="row" style="heigth: 60px">
              <div class="col-lg-6 col-xl-4 mb-2">
                <multiselect
                  v-model="OffersAndPromotion.selectedClient"
                  :placeholder="$tc('Client')"
                  :options="clientList"
                  @select="onSelectClient($event)"
                  label="client_name"
                  track-by="client_id"
                  :multiple="false"
                ></multiselect>
                <!-- <p class="error_message">
            <span
              v-if="
                submitted &&
                  (!OffersAndPromotion.selectedClient ||
                    OffersAndPromotion.selectedClient.length == 0)
              "
              >Please select client.</span
            >
          </p> -->
              </div>

              <div class="col-lg-6 col-xl-4 align-self-center mb-2">
                <div class="d-flex align-items-center justify-content-center">
                  <span>{{ $t("shareValue") }}</span>
                  <div class="input-material-sm mx-2">
                    <input
                      style="text-align: right"
                      v-model="OffersAndPromotion.share_value"
                      v-validate="'decimal'"
                      name="share_value"
                      id="share_value"
                      type="text"
                    />
                  </div>
                </div>
                <p class="error_message">
                  <span v-if="errors.has('share_value')">{{
                    errors.first("share_value")
                  }}</span>
                </p>
              </div>

              <!-- IS PERCENTAGE -->
              <div class="col-lg-6 col-xl-4 mb-2">
                <div
                  class="d-flex align-items-center pt-2 justify-content-center"
                >
                  <b-form-checkbox
                    class="ml-1 j-checkbox"
                    v-model="OffersAndPromotion.share_is_percentage"
                    unchecked-value="N"
                    value="Y"
                  ></b-form-checkbox>

                  <span>{{ $t("Percentage") }}</span>
                </div>
              </div>
            </div>
          </div>
        </b-collapse>
      </section>

       <section class="mb-2">
        <div
          class="
            section-title
            mb-3
            d-flex
            justify-content-between
            section-border section-border
          "
          style="padding: 6px; align-items: center"
          v-b-toggle.otherOfferSettings
        >
          <span class="fs">
            {{'Other'}} {{ $t("offer") }}
            {{ 'Settings' }}</span
          >
          <button type="button" class="btn-transparent chevron">
            <img
              src="@/assets/img/icons/primary/chevron-down.svg"
              height="24"
              width="24"
            />
          </button>
        </div>
        <b-collapse
          id="otherOfferSettings"
          v-model="sectionCollapse.otherOfferSettings"
        >
          <div class="new-border back rounded-10 px-3 pb-0 mb-2">
            <div class="row">
              <div class="col-lg-6 col-xl-4 my-3">
                <div class="d-flex align-items-center justify-content-start">
                  <b-form-checkbox
                    class="j-checkbox pb-0 ml-3"
                    v-model="OffersAndPromotion.is_employee_offer"
                    unchecked-value="N"
                    value="Y"
                    @change="onSelectEmployeeDiscount($event)"
                  ></b-form-checkbox>
                  <span class="font-weight-bold">{{ $t("is_employee_offer") }}</span>
                </div>
              </div>
            </div>
          </div>
        </b-collapse>
      </section>

      <section class="mb-2">
        <div
          class="
            section-title
            mb-3
            d-flex
            justify-content-between
            section-border section-border
          "
          style="padding: 6px; align-items: center"
          v-b-toggle.offertype
        >
          <span class="fs"> {{ $t("offertypes") }}</span>
          <button type="button" class="btn-transparent chevron">
            <img
              src="@/assets/img/icons/primary/chevron-down.svg"
              height="24"
              width="24"
            />
          </button>
        </div>
        <b-collapse id="offertype" v-model="sectionCollapse.offertype">
          <div class="new-border back rounded-10 p-3 mb-2">
            <!--div class="section-title text-uppercase mb-3" style="font-size: 20px">
          {{ $t("offertypes") }}
        </div-->

            <!--New Design-->
            <div class="row">
              <div class="mx-2" v-if="checkOfferTypeAvailable('fixedDiscount')">
                <b-form-radio
                  value="fixedDiscount"
                  class="j-radio"
                  v-model="selectedOfferType"
                  @change="onChangeOfferType($event)"
                >
                  <div>{{ $t("Fixed Discount") }}</div>
                </b-form-radio>
              </div>
              <div class="mx-2" v-if="checkOfferTypeAvailable('buyAndGetFreeTickets')">
                <b-form-radio
                  value="buyAndGetFreeTickets"
                  class="j-radio"
                  v-model="selectedOfferType"
                  @change="onChangeOfferType($event)"
                >
                  <div>{{ $t("buyngetfreeticket") }}</div>
                </b-form-radio>
              </div>
              <div class="mx-2" v-if="checkOfferTypeAvailable('discount')">
                <b-form-radio
                  class="j-radio"
                  value="discount"
                  v-model="selectedOfferType"
                >
                  <div>{{ $t("discounts") }}</div>
                </b-form-radio>
              </div>

              <div class="mx-2" v-if="checkOfferTypeAvailable('buyAndGetCombo')">
                <b-form-radio
                  value="buyAndGetCombo"
                  class="j-radio"
                  v-model="selectedOfferType"
                >
                  <div>{{ $t("buyandgetcombo") }}</div>
                </b-form-radio>
              </div>

              <div class="mx-2" v-if="false">
                <b-form-radio
                  class="j-radio"
                  value="customCategoryOffers"
                  v-model="selectedOfferType"
                >
                  <div>{{ $t("customercategoryoffer") }}</div>
                </b-form-radio>
              </div>

              <div class="mx-2" v-if="false">
                <b-form-radio
                  class="j-radio"
                  value="bankOffer"
                  v-model="selectedOfferType"
                >
                  <div>{{ $t("bank") }} {{ $t("offer") }}</div>
                </b-form-radio>
              </div>

              <div class="mx-2" v-if="checkOfferTypeAvailable('fixedPriceTicketFnb')">
                <b-form-radio
                  class="j-radio"
                  value="fixedPriceTicketFnb"
                  v-model="selectedOfferType"
                  @change="onChangeOfferType($event)"
                >
                  <div>{{ $t("fixedPriceTicketFnb") }}</div>
                </b-form-radio>
              </div>

              <div class="mx-2 mb-2" v-if="checkOfferTypeAvailable('buyAndgetOffOnAnother')">
                <b-form-radio
                  class="j-radio"
                  value="buyAndgetOffOnAnother"
                  v-model="selectedOfferType"
                  @change="onChangeOfferType($event)"
                >
                  <div>{{ $t("buyAndgetOffOnAnother") }}</div>
                </b-form-radio>
              </div>

              <div class="mx-2" v-if="checkOfferTypeAvailable('loyalitycustomers')">
                <b-form-radio
                  class="j-radio"
                  value="loyalitycustomers"
                  v-model="selectedOfferType"
                >
                  <div>{{ $t("loyalityOffers") }}</div>
                </b-form-radio>
              </div>
            </div>

            <div class="row">
              <div class="col-12">
                <!-- Fixed Discount-->
                <div
                  class="offer-content-wrapper pt-3 pl-0"
                  v-if="selectedOfferType == 'fixedDiscount'"
                >
                  <div class="row pl-0 back_white mx-1 pt-2">
                    <div
                      class="col-12 pt-2 pb-0"
                      v-for="(discountList, discountListIndex) in discountLists"
                      :key="discountListIndex"
                    >
                      <div class="row">
                        <div class="col-lg-10 col-xl-11">
                          <div class="row">
                            <div
                              class="col-lg-12 col-xl-4 align-self-center mb-2"
                            >
                              <div class="d-flex align-items-center">
                                {{ $t("Offer Value :") }}
                                <div class="input-material mx-1">
                                  <input
                                    style="text-align: right"
                                    name="discount_buy_value"
                                    id="discount_buy_value"
                                    v-validate="'required|numeric'"
                                    type="number"
                                    @input="
                                      onChangeDiscountValue(
                                        $event,
                                        discountListIndex
                                      )
                                    "
                                    v-model="discountList.oc_discount_value"
                                  />
                                </div>
                              </div>
                              <p
                                v-if="
                                  submitted && errors.has('discount_buy_value')
                                "
                                class="error_message"
                              >
                                <span>{{
                                  errors.first("discount_buy_value")
                                }}</span>
                              </p>
                            </div>
                            <div
                              class="col-lg-6 col-xl-2 align-self-center mb-2"
                            >
                              <div class="d-flex align-items-center">
                                <b-form-checkbox
                                  class="j-checkbox pb-0"
                                  v-model="
                                    discountList.oc_discount_value_is_percentage
                                  "
                                  unchecked-value="N"
                                  value="Y"
                                ></b-form-checkbox>
                                {{ $t("Percentage") }}
                              </div>
                            </div>
                            <div
                              v-if="
                                discountList.oc_discount_value_is_percentage ==
                                  'Y'
                              "
                              class="col-lg-12 col-xl-4 align-self-center mb-lg-2 mb-xl-2"
                            >
                              <div class="d-flex align-items-center">
                                {{ $t("maxdiscountpertransaction") }}
                                <div class="input-material-sm mx-2">
                                  <input
                                    style="text-align: right"
                                    type="number"
                                    name="max_discount_per_trans"
                                    id="max_discount_per_trans"
                                    v-validate="'required|numeric'"
                                    v-model="
                                      discountList.oc_max_discount_amount
                                    "
                                  />
                                </div>
                              </div>
                              <p
                                v-if="
                                  submitted &&
                                  errors.has('max_discount_per_trans')
                                "
                                class="error_message"
                              >
                                <span>{{
                                  errors.first("max_discount_per_trans")
                                }}</span>
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!--Buy/Get free ticket-->
                <div
                  class="offer-content-wrapper pl-0"
                  style="padding-top: 20px"
                  v-if="selectedOfferType == 'buyAndGetFreeTickets'"
                >
                  <div class="row back_white mx-1 pt-2">
                    <div class="col-lg-12 col-xl-4 mb-2">
                      <div class="d-flex align-items-center">
                        {{ $t("buy") }}
                        <div class="input-material-sm mx-1">
                          <input
                            style="text-align: right"
                            v-model="buyAndGetFreeTickets.oc_buy_no_of_ticket"
                            type="text"
                            name="buy_value"
                            id="buy_value"
                            v-validate="
                              selectedOfferType == 'buyAndGetFreeTickets'
                                ? 'required|numeric'
                                : ''
                            "
                          />
                        </div>
                        {{ $t("get") }}
                        <div class="input-material-sm mx-2">
                          <input
                            v-model="buyAndGetFreeTickets.oc_get_free_ticket"
                            type="text"
                            name="get_value"
                            id="get_value"
                            v-validate="'required|numeric'"
                          />
                        </div>
                        {{ $t("ofticketsfree") }}
                      </div>
                      <p
                        v-if="
                          (submitted && errors.has('buy_value')) ||
                          (submitted && errors.has('get_value'))
                        "
                        class="error_message"
                      >
                        <span>{{
                          errors.first("buy_value") || errors.first("get_value")
                        }}</span>
                      </p>
                    </div>

                    <div class="col-lg-12 col-xl-4 mb-2">
                      <div
                        class="d-flex align-items-center justify-content-center"
                      >
                        {{ $tc("minTicketAmount") }}
                        <div class="input-material-sm mx-2">
                          <input
                            style="text-align: right"
                            v-model="buyAndGetFreeTickets.oc_min_ticket_price"
                            type="text"
                            name="min_ticket_amount"
                            id="min_ticket_amount"
                            v-validate="'required|decimal'"
                          />
                        </div>
                      </div>
                      <p
                        v-if="submitted && errors.has('min_ticket_amount')"
                        class="error_message"
                      >
                        <span>{{ errors.first("min_ticket_amount") }}</span>
                      </p>
                    </div>

                    <div class="col-lg-12 col-xl-4 mb-2">
                      <div class="d-flex align-items-center">
                        {{ $t("maxfreeticketpertransaction") }}
                        <div class="input-material-sm mx-2">
                          <input
                            style="text-align: right"
                            v-model="
                              buyAndGetFreeTickets.oc_max_no_of_ticket_per_transaction
                            "
                            type="text"
                            name="max_ticket"
                            id="max_ticket"
                            v-validate="'required|numeric'"
                          />
                        </div>
                      </div>
                      <p
                        v-if="submitted && errors.has('max_ticket')"
                        class="error_message"
                      >
                        <span>{{ errors.first("max_ticket") }}</span>
                      </p>
                    </div>

                    <!-- <div class="col-lg-12 col-xl-12 align-self-center mb-4" style="height:38px;">
                    <div class="d-flex align-items-center">
                      {{ $t('cancombinewithotheroffers') }}
                      <b-form-checkbox
                        class="ml-3"
                        v-model="buyAndGetFreeTickets.oc_combine_with_other_offers"
                        unchecked-value="N"
                        value="Y"
                        switch
                      ></b-form-checkbox>
                    </div>
                  </div> 
                  <div class="col-lg-12 col-xl-12 align-self-center mb-4">
                    <b-collapse v-model="buyAndGetFreeTickets.oc_combine_with_other_offers === 'Y'">
                      <div class="d-flex align-items-center">
                        <b-form-select
                          class="select-curve w-75"
                          :options="currentlyActiveOffers"
                          v-model="buyAndGetFreeTickets.selectedCombineoffer"
                        ></b-form-select>
                      </div>
                    </b-collapse>
                  </div>-->
                  </div>
                </div>

                <!--Discount-->
                <div
                  class="offer-content-wrapper pt-3 pl-0"
                  v-if="selectedOfferType == 'discount'"
                >
                  <div class="row pl-0 back_white mx-1 pt-2">
                    <div
                      class="col-12 pt-2 pb-0"
                      v-for="(discountList, discountListIndex) in discountLists"
                      :key="discountListIndex"
                    >
                      <div class="row">
                        <div class="col-lg-10 col-xl-11">
                          <div class="row">
                            <div
                              class="col-lg-12 col-xl-6 align-self-center mb-2"
                            >
                              <div class="d-flex align-items-center">
                                {{ $t("buy") }}
                                <div class="input-material-sm mx-1">
                                  <input
                                    style="text-align: right"
                                    name="discount_buy_value"
                                    id="discount_buy_value"
                                    v-validate="'required|numeric'"
                                    type="text"
                                    v-model="discountList.oc_buy_no_of_ticket"
                                  />
                                </div>
                                {{ $t("ticket_fnbitem") }}
                                <div class="input-material-sm mx-2">
                                  <input
                                    style="text-align: right"
                                    type="text"
                                    name="discount_get_value"
                                    id="discount_get_value"
                                    v-validate="'required|numeric'"
                                    v-model="discountList.oc_discount_value"
                                  />
                                </div>
                              </div>
                              <p
                                v-if="
                                  (submitted &&
                                    errors.has('discount_buy_value')) ||
                                  (submitted &&
                                    errors.has('discount_get_value'))
                                "
                                class="error_message"
                              >
                                <span>{{
                                  errors.first("discount_buy_value") ||
                                  errors.first("discount_get_value")
                                }}</span>
                              </p>
                            </div>
                            <div
                              class="col-lg-6 col-xl-2 align-self-center mb-2"
                            >
                              <div class="d-flex align-items-center">
                                <b-form-checkbox
                                  class="j-checkbox pb-0"
                                  v-model="
                                    discountList.oc_discount_value_is_percentage
                                  "
                                  unchecked-value="N"
                                  value="Y"
                                ></b-form-checkbox>
                                {{ $t("Percentage") }}
                              </div>
                            </div>
                            <div
                              class="
                                col-lg-12 col-xl-4
                                align-self-center
                                mb-lg-2 mb-xl-2
                              "
                            >
                              <div class="d-flex align-items-center">
                                {{ $t("maxdiscountpertransaction") }}
                                <div class="input-material-sm mx-2">
                                  <input
                                    style="text-align: right"
                                    type="text"
                                    name="max_discount_per_trans"
                                    id="max_discount_per_trans"
                                    v-validate="'required|numeric'"
                                    v-model="
                                      discountList.oc_max_discount_amount
                                    "
                                  />
                                </div>
                              </div>
                              <p
                                v-if="
                                  submitted &&
                                  errors.has('max_discount_per_trans')
                                "
                                class="error_message"
                              >
                                <span>{{
                                  errors.first("max_discount_per_trans")
                                }}</span>
                              </p>
                            </div>
                            <!-- <div
                            class="col-lg-12 col-xl-4 align-self-center mb-lg-4 mb-xl-0"
                            style="height:38px;"
                          >
                            <div class="d-flex align-items-center h-100">
                              {{ $t('cancombinewithotheroption') }}
                              <b-form-checkbox
                                class="ml-3"
                                v-model="discountList.canCombineOtherOffers"
                                unchecked-value="N"
                                value="Y"
                                switch
                              ></b-form-checkbox>
                            </div>
                          </div>
                          <div class="col-lg-6 col-xl-4 align-self-center">
                            <b-collapse v-model="discountList.canCombineOtherOffers === 'Y'">
                              <div class="d-flex align-items-center">
                                <b-form-select
                                  class="select-curve w-75"
                                  :options="currentlyActiveOffers"
                                  v-model="discountList.selectedCombinedOffer"
                                ></b-form-select>
                              </div>
                            </b-collapse>
                          </div>-->
                          </div>
                        </div>
                        <div
                          class="
                            col-lg-2 col-xl-1
                            d-flex
                            justify-content-center
                            align-items-center
                          "
                          v-if="false"
                        >
                          <button
                            class="btn-transparent mb-3"
                            @click="addDiscount()"
                            v-if="discountListIndex == 0"
                          >
                            <img
                              src="@/assets/img/icons/plus.svg"
                              height="35"
                              width="35"
                            />
                          </button>

                          <!-- <button
                          v-if="discountListIndex === 0 && discountLists.length !== 1"
                          class="btn-transparent mb-3"
                          @click="removeDiscount(discountListIndex)"
                        >
                          <img src="@/assets/img/icons/minus.svg" height="35" width="35" />
                        </button>-->

                          <button
                            v-if="discountListIndex !== 0"
                            class="btn-transparent mb-3"
                            @click="removeDiscount(discountListIndex)"
                          >
                            <img
                              src="@/assets/img/icons/minus.svg"
                              height="35"
                              width="35"
                            />
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!--Loyality Program Offers-->
                <div
                  class="offer-content-wrapper pt-3 pl-0"
                  v-if="selectedOfferType == 'loyalitycustomers'"
                >
                  <div class="row pl-0 back_white mx-1 pt-2">
                    <div
                      class="col-12 pt-2 pb-0"
                      v-for="(discountList, discountListIndex) in discountLists"
                      :key="discountListIndex"
                    >
                      <div class="row">
                        <div class="col-lg-10 col-xl-11">
                          <div class="row">
                            <div
                              class="col-lg-12 col-xl-6 align-self-center mb-2"
                            >
                              <div class="d-flex align-items-center">
                                {{ $t("buy") }}
                                <div class="input-material-sm mx-1">
                                  <input
                                    style="text-align: right"
                                    name="discount_buy_value"
                                    id="discount_buy_value"
                                    v-validate="'required|numeric'"
                                    type="text"
                                    v-model="discountList.oc_buy_no_of_ticket"
                                  />
                                </div>
                                {{ $t("ticket_fnbitem") }}
                                <div class="input-material-sm mx-2">
                                  <input
                                    style="text-align: right"
                                    type="text"
                                    name="discount_get_value"
                                    id="discount_get_value"
                                    v-validate="'required|numeric'"
                                    v-model="discountList.oc_discount_value"
                                  />
                                </div>
                              </div>
                              <p
                                v-if="
                                  (submitted &&
                                    errors.has('discount_buy_value')) ||
                                  (submitted &&
                                    errors.has('discount_get_value'))
                                "
                                class="error_message"
                              >
                                <span>{{
                                  errors.first("discount_buy_value") ||
                                  errors.first("discount_get_value")
                                }}</span>
                              </p>
                            </div>
                            <div
                              class="col-lg-6 col-xl-2 align-self-center mb-2"
                            >
                              <div class="d-flex align-items-center">
                                <b-form-checkbox
                                  class="j-checkbox pb-0"
                                  v-model="
                                    discountList.oc_discount_value_is_percentage
                                  "
                                  unchecked-value="N"
                                  value="Y"
                                ></b-form-checkbox>
                                {{ $t("Percentage") }}
                              </div>
                            </div>
                            <div
                              class="
                                col-lg-12 col-xl-4
                                align-self-center
                                mb-lg-2 mb-xl-2
                              "
                            >
                              <div class="d-flex align-items-center">
                                {{ $t("maxdiscountpertransaction") }}
                                <div class="input-material-sm mx-2">
                                  <input
                                    style="text-align: right"
                                    type="text"
                                    name="max_discount_per_trans"
                                    id="max_discount_per_trans"
                                    v-validate="'required|numeric'"
                                    v-model="
                                      discountList.oc_max_discount_amount
                                    "
                                  />
                                </div>
                              </div>
                              <p
                                v-if="
                                  submitted &&
                                  errors.has('max_discount_per_trans')
                                "
                                class="error_message"
                              >
                                <span>{{
                                  errors.first("max_discount_per_trans")
                                }}</span>
                              </p>
                            </div>
                            <!-- <div
                            class="col-lg-12 col-xl-4 align-self-center mb-lg-4 mb-xl-0"
                            style="height:38px;"
                          >
                            <div class="d-flex align-items-center h-100">
                              {{ $t('cancombinewithotheroption') }}
                              <b-form-checkbox
                                class="ml-3"
                                v-model="discountList.canCombineOtherOffers"
                                unchecked-value="N"
                                value="Y"
                                switch
                              ></b-form-checkbox>
                            </div>
                          </div>
                          <div class="col-lg-6 col-xl-4 align-self-center">
                            <b-collapse v-model="discountList.canCombineOtherOffers === 'Y'">
                              <div class="d-flex align-items-center">
                                <b-form-select
                                  class="select-curve w-75"
                                  :options="currentlyActiveOffers"
                                  v-model="discountList.selectedCombinedOffer"
                                ></b-form-select>
                              </div>
                            </b-collapse>
                          </div>-->
                          </div>
                        </div>
                        <div
                          class="
                            col-lg-2 col-xl-1
                            d-flex
                            justify-content-center
                            align-items-center
                          "
                          v-if="false"
                        >
                          <button
                            class="btn-transparent mb-3"
                            @click="addDiscount()"
                            v-if="discountListIndex == 0"
                          >
                            <img
                              src="@/assets/img/icons/plus.svg"
                              height="35"
                              width="35"
                            />
                          </button>

                          <!-- <button
                          v-if="discountListIndex === 0 && discountLists.length !== 1"
                          class="btn-transparent mb-3"
                          @click="removeDiscount(discountListIndex)"
                        >
                          <img src="@/assets/img/icons/minus.svg" height="35" width="35" />
                        </button>-->

                          <button
                            v-if="discountListIndex !== 0"
                            class="btn-transparent mb-3"
                            @click="removeDiscount(discountListIndex)"
                          >
                            <img
                              src="@/assets/img/icons/minus.svg"
                              height="35"
                              width="35"
                            />
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!--Buy And Get Como-->
                <div
                  class="offer-content-wrapper py-0 pl-0"
                  v-if="selectedOfferType == 'buyAndGetCombo'"
                >
                  <div class="row back_white p-2 mx-1 mt-3">
                    <div
                      class="col-lg-12 col-xl-12 align-self-center mb-4 pl-0"
                    >
                      <div class="d-flex">
                        {{ $t("combinewith") }}:
                        <b-form-radio
                          value="fAndb"
                          class="j-radio ml-4"
                          v-model="buyAndGetCombo.offerApplicableAt"
                        >
                          <div>F&amp;B</div>
                        </b-form-radio>
                        <b-form-radio
                          value="boxOffice"
                          class="j-radio ml-3"
                          v-model="buyAndGetCombo.offerApplicableAt"
                        >
                          <div>{{ $t("boxoffice") }}</div>
                        </b-form-radio>
                      </div>
                    </div>
                    <div
                      class="col-12"
                      v-if="buyAndGetCombo.offerApplicableAt === 'fAndb'"
                    >
                      <div class="row">
                        <div class="col-lg-12 col-xl-12 pl-0">
                          <div class="row mx-0 align-items-center">
                            <div class="mb-0">
                              <span class="text-nowrap">{{ $t("buy") }}</span>
                            </div>
                            <div class="input-material-sm mx-1">
                              <input
                                v-model="
                                  buyAndGetCombo.F_And_B.oc_buy_item_count
                                "
                                type="text"
                                name="buy_fnb_combo"
                                id="buy_fnb_combo"
                                v-validate="'required|numeric'"
                              />
                            </div>

                            <div class="col-2">
                              <multiselect
                                v-model="buyAndGetCombo.F_And_B.oc_buy_item_id"
                                :options="fnbItems"
                                :placeholder="$tc('fnbitems')"
                                label="item_name"
                                isSingleId="item_id"
                                :multiple="false"
                                track-by="item_id"
                              >
                                <span slot="option" slot-scope="props"
                                  >{{ props.option.item_name }}&nbsp;
                                  <p
                                    class="spanText text-muted"
                                    v-if="props.option.cine_name"
                                  >
                                    {{ props.option.cine_name }}
                                  </p></span
                                >
                              </multiselect>
                            </div>
                            <span class="text-nowrap">{{ $t("get") }}</span>

                            <div class="input-material-sm mx-2">
                              <input
                                style="text-align: right"
                                v-model="
                                  buyAndGetCombo.F_And_B.oc_get_item_count
                                "
                                type="text"
                                name="get_fnb_combo"
                                id="get_fnb_combo"
                                v-validate="
                                  buyAndGetCombo.offerApplicableAt == 'fAndb'
                                    ? 'required|numeric'
                                    : ''
                                "
                              />
                            </div>

                            <div class="col-2">
                              <multiselect
                                v-model="buyAndGetCombo.F_And_B.oc_get_item_id"
                                :options="fnbItems"
                                :placeholder="$tc('fnbitems')"
                                label="item_name"
                                isSingleId="item_id"
                                :multiple="false"
                                track-by="item_id"
                              >
                                <span slot="option" slot-scope="props"
                                  >{{ props.option.item_name }}&nbsp;
                                  <p
                                    class="spanText text-muted"
                                    v-if="props.option.cine_name"
                                  >
                                    {{ props.option.cine_name }}
                                  </p></span
                                >
                              </multiselect>
                            </div>
                            <div class="d-flex align-items-center">
                              <b-form-checkbox
                                class="j-checkbox pb-0 ml-3"
                                v-model="
                                  buyAndGetCombo.F_And_B.oc_is_combo_free
                                "
                                unchecked-value="N"
                                value="Y"
                              ></b-form-checkbox>
                              <span class="text-nowrap">Free</span>
                            </div>

                            <div
                              v-if="
                                buyAndGetCombo.F_And_B.oc_is_combo_free === 'N'
                              "
                              style="display: flex"
                            >
                              <div class="d-flex align-items-center ml-3">
                                <span class="text-nowrap"
                                  >&nbsp;{{ $t("offer") }}
                                  {{ $t("value") }}</span
                                >
                                <div class="input-material-sm mx-2">
                                  <input
                                    style="text-align: right"
                                    type="text"
                                    name="free_combo_offer_value"
                                    id="free_combo_offer_value"
                                    v-validate="'required|decimal'"
                                    v-model="
                                      buyAndGetCombo.F_And_B.oc_discount_value
                                    "
                                  />
                                </div>
                              </div>
                              <div class="d-flex align-items-center">
                                <b-form-checkbox
                                  class="j-checkbox pb-0 ml-3"
                                  v-model="
                                    buyAndGetCombo.F_And_B
                                      .oc_discount_value_is_percentage
                                  "
                                  unchecked-value="N"
                                  value="Y"
                                ></b-form-checkbox>
                                {{ $t("Percentage") }}
                              </div>
                            </div>
                          </div>
                          <p
                            v-if="
                              (submitted && errors.has('buy_fnb_combo')) ||
                              errors.has('get_fnb_combo') ||
                              (buyAndGetCombo.F_And_B.oc_is_combo_free ===
                                'N' &&
                                errors.has('free_combo_offer_value'))
                            "
                            class="error_message"
                          >
                            <span>{{
                              errors.first("buy_fnb_combo") ||
                              errors.first("get_fnb_combo") ||
                              errors.first("free_combo_offer_value")
                            }}</span>
                          </p>
                          <p
                            v-else-if="
                              submitted &&
                              buyAndGetCombo.F_And_B.oc_buy_item_count !=
                                null &&
                              buyAndGetCombo.F_And_B.oc_buy_item_id == null
                            "
                            class="error_message"
                          >
                            <span>Please select F&B item for Buy.</span>
                          </p>
                          <p
                            v-else-if="
                              submitted &&
                              buyAndGetCombo.F_And_B.oc_get_item_count !=
                                null &&
                              buyAndGetCombo.F_And_B.oc_get_item_id == null
                            "
                            class="error_message"
                          >
                            <span>Please select F&B item for Get.</span>
                          </p>
                        </div>
                      </div>
                    </div>

                    <div
                      class="col-12"
                      v-if="buyAndGetCombo.offerApplicableAt === 'boxOffice'"
                    >
                      <div class="row">
                        <div class="col-lg-12 col-xl-12 pl-0">
                          <div class="row mx-0 align-items-center">
                            <div>
                              <span class="text-nowrap">{{ $t("buy") }}</span>
                            </div>
                            <div class="input-material-sm mx-1">
                              <input
                                style="text-align: right"
                                v-model="
                                  buyAndGetCombo.boxOffice.oc_buy_no_of_ticket
                                "
                                type="text"
                                name="buy_bo_combo"
                                id="buy_bo_combo"
                                v-validate="'required|numeric'"
                              />
                            </div>

                            <span class="text-nowrap"
                              >{{ $t("tickets") }}&nbsp;{{ $t("get") }}</span
                            >

                            <div class="col-3">
                              <!-- <input v-model="buyAndGetCombo.boxOffice.getCount" type="number" /> -->

                              <multiselect
                                v-model="
                                  buyAndGetCombo.boxOffice.oc_get_item_id
                                "
                                :options="fnbItems"
                                :placeholder="$tc('fnbitems')"
                                label="item_name"
                                isSingleId="item_id"
                                :multiple="false"
                                track-by="item_id"
                              ></multiselect>
                            </div>
                            <!-- <span class="text-nowrap">{{ $t('tickets') }}&nbsp;&nbsp;</span> -->
                            <div class="d-flex align-items-center" style="">
                              <b-form-checkbox
                                class="j-checkbox pb-0 ml-1"
                                v-model="
                                  buyAndGetCombo.boxOffice.oc_is_combo_free
                                "
                                unchecked-value="N"
                                value="Y"
                              ></b-form-checkbox>

                              <span class="text-nowrap">{{ $t("free") }}</span>
                            </div>
                            <div
                              v-if="
                                buyAndGetCombo.boxOffice.oc_is_combo_free ===
                                'N'
                              "
                              style="display: flex"
                            >
                              <div class="d-flex align-items-center ml-5">
                                <span class="text-nowrap"
                                  >&nbsp;{{ $t("offer") }}
                                  {{ $t("value") }}</span
                                >
                                <div class="input-material-sm mx-2">
                                  <input
                                    style="text-align: right"
                                    type="text"
                                    name="free_combo_bo_offer_value"
                                    id="free_combo_bo_offer_value"
                                    v-validate="'required|decimal'"
                                    v-model="
                                      buyAndGetCombo.boxOffice.oc_discount_value
                                    "
                                  />
                                </div>
                              </div>
                              <div class="d-flex align-items-center">
                                <b-form-checkbox
                                  class="j-checkbox pb-0 ml-3"
                                  v-model="
                                    buyAndGetCombo.boxOffice
                                      .oc_discount_value_is_percentage
                                  "
                                  unchecked-value="N"
                                  value="Y"
                                  switch
                                ></b-form-checkbox>
                                {{ $t("isPercentage") }}
                              </div>
                            </div>
                          </div>
                          <p
                            v-if="
                              (submitted && errors.has('buy_bo_combo')) ||
                              (buyAndGetCombo.boxOffice.oc_is_combo_free ===
                                'N' &&
                                errors.has('free_combo_bo_offer_value'))
                            "
                            class="error_message"
                          >
                            <span>{{
                              errors.first("buy_bo_combo") ||
                              errors.first("free_combo_bo_offer_value")
                            }}</span>
                          </p>
                          <p
                            v-else-if="
                              submitted &&
                              buyAndGetCombo.boxOffice.oc_buy_no_of_ticket !=
                                null &&
                              buyAndGetCombo.boxOffice.oc_get_item_id == null
                            "
                            class="error_message"
                          >
                            <span>Please select F&B item for get.</span>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!--Fixed Price Ticket And FNB-->
                <div
                  class="offer-content-wrapper py-0 pl-0"
                  v-if="selectedOfferType == 'fixedPriceTicketFnb'"
                >
                  <div class="row back_white p-2 mx-1 mt-3">
                    <div class="col-lg-12 col-xl-12">
                      <div class="row mx-0 align-items-center">
                        <div>
                          <span class="text-nowrap">{{ $t("buy") }}</span>
                        </div>
                        <div class="input-material-sm mx-1">
                          <input
                            style="text-align: right"
                            v-model="buyTicketFnbFixedPrice.oc_buy_no_of_ticket"
                            type="text"
                            name="buy_fixed_price_ticket_count"
                            id="buy_fixed_price_ticket_count"
                             @input="onChangeCount($event,'buyTicketFnbFixedPrice', 'buy')"
                            v-validate="'required'"
                          />
                        </div>

                        <span class="text-nowrap">{{ $t("tickets") }}</span>

                        <div style="display: flex">
                          <div class="d-flex align-items-center ml-2">
                            <span class="text-nowrap"
                              >{{ $t("atFlatRate") }}&nbsp;</span
                            >
                            <div class="input-material-sm mx-2">
                              <input
                                style="text-align: right"
                                type="text"
                                name="fixedPrice_bo_offer_value"
                                id="fixedPrice_bo_offer_value"
                                v-validate="'required'"
                                v-model="
                                  buyTicketFnbFixedPrice.oc_ticket_at_price
                                "
                              />
                            </div>
                            <span class="text-nowrap">{{ $t("Each") }}</span>
                          </div>
                        </div>

                        <div class="d-flex align-items-center">
                          <b-form-checkbox
                            class="j-checkbox pb-0 ml-5"
                            id="combineFixedTicketFnb"
                            name="combineFixedTicketFnb"
                            v-model="buyTicketFnbFixedPrice.oc_combine_with_fnb"
                            unchecked-value="N"
                            value="Y"
                          >
                          </b-form-checkbox>
                          <label class="mt-2" for="combineFixedTicketFnb">
                            {{ $t("combinewithfnb") }}</label
                          >
                        </div>

                        <div style="display: flex">
                          <div class="d-flex align-items-center ml-5">
                            <span class="text-nowrap"
                              >{{ "Max Ticket Limit" }}&nbsp;</span
                            >
                            <div class="input-material-sm mx-2">
                              <input
                                style="text-align: right"
                                type="text"
                                name="mx_count_ticket"
                                id="mx_count_ticket"
                                @change="onChangeCount($event,'buyTicketFnbFixedPrice', 'max')"
                                v-model="
                                  buyTicketFnbFixedPrice.oc_max_count_of_ticket
                                "
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- SHOW ERROR HERE -->
                    </div>

                    <div
                      class="col-lg-12 col-xl-12 pl-0 mt-3"
                      v-if="buyTicketFnbFixedPrice.oc_combine_with_fnb == 'Y'"
                    >
                      <div
                        class="row mx-0 align-items-center mb-3"
                        v-for="(
                          fnbCombo, fnbComboIndex
                        ) in buyTicketFnbFixedPrice.Fnb_criteria"
                        :key="fnbComboIndex"
                      >
                        <div class="col-md-1">
                          <div
                            class="
                              d-flex
                              align-items-center
                              justify-content-between
                            "
                          >
                            <div>
                              <span class="text-nowrap">{{ $t("buy") }}</span>
                            </div>
                            <div class="input-material-sm mx-1">
                              <input
                                style="text-align: right"
                                v-model="fnbCombo.oc_buy_no_of_item"
                                type="text"
                                name="buy_fixedprice_item"
                                id="buy_fixedprice_item"
                                v-validate="'required'"
                              />
                            </div>
                          </div>
                        </div>

                        <div class="col-md-3">
                          <div class="">
                            <multiselect
                              v-model="fnbCombo.selectedFnbItem"
                              @select="
                                selectFnbItemFixedOffer(
                                  $event,
                                  fnbComboIndex,
                                  'Add'
                                )
                              "
                              @remove="
                                selectFnbItemFixedOffer(
                                  $event,
                                  fnbComboIndex,
                                  'Remove'
                                )
                              "
                              :options="fnbItems"
                              :placeholder="$tc('fnbitems')"
                              label="item_name"
                              isSingleId="item_id"
                              :multiple="false"
                              track-by="item_id"
                            ></multiselect>
                          </div>
                        </div>

                        <div class="col-md-2">
                          <div style="display: flex">
                            <div class="d-flex align-items-center">
                              <span class="text-nowrap"
                                >{{ $t("atFlatRate") }}&nbsp;</span
                              >
                              <div class="input-material-sm mx-2">
                                <input
                                  style="text-align: right"
                                  type="text"
                                  name="fixed_fnb_bo_offer_value"
                                  id="fixed_fnb_bo_offer_value"
                                  v-validate="'required'"
                                  v-model="fnbCombo.oc_fnb_at_price"
                                />
                              </div>
                              <span class="text-nowrap">{{ $t("Each") }}</span>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-2">
                          <div
                            class="
                              d-flex
                              justify-content-center
                              align-items-center
                            "
                          >
                            <button
                              class="btn-transparent"
                              @click="addFnbCriteria()"
                              v-if="fnbComboIndex == 0"
                            >
                              <img
                                src="@/assets/img/icons/plus.svg"
                                height="29"
                                width="29"
                              />
                            </button>
                            <button
                              v-if="fnbComboIndex !== 0"
                              class="btn-transparent"
                              @click="removeFnbCriteria(fnbComboIndex)"
                            >
                              <img
                                src="@/assets/img/icons/minus.svg"
                                height="29"
                                width="29"
                              />
                            </button>
                          </div>
                        </div>
                      </div>
                      <!-- SHOW ERROR HERE -->
                    </div>
                  </div>
                </div>

                <!--Buy 1 get Off on Another Ticket-->
                <div
                  class="offer-content-wrapper py-0 pl-0"
                  v-if="selectedOfferType == 'buyAndgetOffOnAnother'"
                >
                  <div class="row back_white p-2 mx-1 mt-3">
                    <div class="col-lg-12 col-xl-12">
                      <div
                        class="row d-flex mx-0 align-items-center"
                        style="gap: 35px"
                      >
                        <div class="align-self-center mb-2">
                          <div class="d-flex align-items-center">
                            {{ $t("buy") }}
                            <div class="input-material-sm mx-1">
                              <input
                                style="text-align: right"
                                name="discount_buy_value"
                                id="discount_buy_value"
                                v-validate="'required|numeric'"
                                type="text"
                                @input="onChangeCount($event,'buyAndgetOffOnAnother', 'buy')"
                                v-model="
                                  buyAndgetOffOnAnother.oc_buy_no_of_ticket
                                "
                              />
                            </div>
                            {{ $t("buyAndgetOffOnAnother_des") }}
                            <div class="input-material-sm mx-2">
                              <input
                                style="text-align: right"
                                type="text"
                                name="discount_get_value"
                                id="discount_get_value"
                                v-validate="'required|numeric'"
                                v-model="
                                  buyAndgetOffOnAnother.oc_discount_value
                                "
                              />
                            </div>
                            <span
                              v-if="
                                buyAndgetOffOnAnother.oc_discount_value_is_percentage ==
                                'Y'
                              "
                              >{{ "%" }}</span
                            >
                            <span v-else>{{ "Flat" }}</span>
                            &nbsp;
                            {{ $t("buyAndgetOffOnAnother_des2") }}
                          </div>
                          <p
                            v-if="
                              (submitted && errors.has('discount_buy_value')) ||
                              (submitted && errors.has('discount_get_value'))
                            "
                            class="error_message"
                          >
                            <span>{{
                              errors.first("discount_buy_value") ||
                              errors.first("discount_get_value")
                            }}</span>
                          </p>
                        </div>
                        <div class="align-self-center mb-2">
                          <div class="d-flex align-items-center">
                            <b-form-checkbox
                              class="j-checkbox pb-0"
                              v-model="
                                buyAndgetOffOnAnother.oc_discount_value_is_percentage
                              "
                              unchecked-value="N"
                              value="Y"
                            ></b-form-checkbox>
                            {{ $t("Percentage") }}
                          </div>
                        </div>
                        <div class="align-self-center mb-lg-2 mb-xl-2" v-if="false">
                          <div class="d-flex align-items-center">
                            {{ "Upto" }}
                            <div class="input-material-sm mx-2">
                              <input
                                style="text-align: right"
                                type="text"
                                name="max_discount_per_trans"
                                id="max_discount_per_trans"
                                v-model="
                                  buyAndgetOffOnAnother.oc_max_discount_amount
                                "
                              />
                            </div>
                          </div>
                        </div>

                        <div class="align-self-center mb-lg-2 mb-xl-2">
                          <div class="d-flex align-items-center">
                            {{ "Max Ticket Limit" }}
                            <div class="input-material-sm mx-2">
                              <input
                                style="text-align: right"
                                type="text"
                                name="max_discount_per_trans"
                                id="max_discount_per_trans"
                                @change="onChangeCount($event,'buyAndgetOffOnAnother', 'max')"
                                v-model="
                                  buyAndgetOffOnAnother.oc_max_count_of_ticket
                                "
                              />
                            </div>
                          </div>
                        </div>

                        <div class="d-flex align-self-center mb-lg-2 mb-xl-2">
                          <div class="mx-2 mb-2">
                            <b-form-radio
                              value="N"
                              class="j-radio"
                              v-model="
                                buyAndgetOffOnAnother.oc_offer_on_higher_amount
                              "
                            >
                              <div>{{ "Lower Price" }}</div>
                            </b-form-radio>
                          </div>
                          <div class="mx-2 mb-2">
                            <b-form-radio
                              value="Y"
                              class="j-radio"
                              v-model="
                                buyAndgetOffOnAnother.oc_offer_on_higher_amount
                              "
                            >
                              <div>{{ "Higher Price" }}</div>
                            </b-form-radio>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Customer Category Offer -->
                <div
                  class="offer-content-wrapper back_white mt-3 p-3"
                  v-if="selectedOfferType == 'customCategoryOffers'"
                >
                  <div class="row">
                    <div class="col-lg-8 align-self-center mb-4">
                      <div class="d-flex">
                        <b-form-radio
                          v-for="(Item, ItmeIndex) in customerOffersCategories"
                          :key="ItmeIndex"
                          @change="onChangeCustomerCategory"
                          v-model="
                            customCategoryOffers.booking_user_category_id
                          "
                          :value="Item.buc_id"
                          class="j-radio col"
                        >
                          <div>{{ $t(Item.buc_category_name) }}&nbsp;</div>
                        </b-form-radio>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div
                      v-if="
                        String(
                          customCategoryOffers.booking_user_category_id
                        ) === String(2) ||
                        String(
                          customCategoryOffers.booking_user_category_id
                        ) === String(4)
                      "
                      class="col-lg-12 col-xl-6 align-self-center mb-3"
                    >
                      <div class="d-flex align-items-center">
                        <multiselect
                          v-model="customCategoryOffers.institution_id"
                          :options="institutionList"
                          :placeholder="$tc('Institute')"
                          label="institution_name"
                          isSingleId="institution_id"
                          :multiple="false"
                          track-by="institution_id"
                        ></multiselect>

                        <p
                          v-if="
                            submitted &&
                            customCategoryOffers.institution_id == null
                          "
                          class="error_message"
                        >
                          <span>{{ $t("pleaseSelectInstitution") }}</span>
                        </p>
                      </div>
                    </div>

                    <div
                      class="align-self-center mb-4"
                      :class="
                        String(
                          customCategoryOffers.booking_user_category_id
                        ) === String(2) ||
                        String(
                          customCategoryOffers.booking_user_category_id
                        ) === String(4)
                          ? 'col-lg-6'
                          : 'col-lg-12'
                      "
                    >
                      <div class="d-flex align-items-center">
                        <div class="mr-3 text-nowrap">
                          {{ $t("validateby") }}:
                        </div>
                        <div class="multiselect">
                          <custommultiselect
                            v-model="customCategoryOffers.validate_doc_id"
                            :options="verificationList"
                            :placeholder="$tc('selectVerificationid')"
                            label="vd_document_name"
                            :multiple="true"
                            track-by="vd_id"
                          ></custommultiselect>
                        </div>
                        <p
                          v-if="
                            submitted &&
                            selectedOfferType == 'customCategoryOffers' &&
                            customCategoryOffers.validate_doc_id == null
                          "
                          class="error_message"
                        >
                          <span
                            >{{ $t("please") }}
                            {{ $t("selectVerificationid") }}</span
                          >
                        </p>
                      </div>
                    </div>

                    <div class="col-lg-5 col-xl-3 mb-4">
                      <div class="d-flex align-items-center">
                        {{ $tc("minimumTicketAmount") }}
                        <div class="input-material-sm mx-2">
                          <input
                            style="text-align: right"
                            v-model="customCategoryOffers.cco_min_ticket_amount"
                            type="text"
                            name="customer_min_ticket_amount"
                            id="customer_min_ticket_amount"
                            v-validate="'required|decimal'"
                          />
                        </div>
                      </div>
                      <p
                        v-if="
                          submitted && errors.has('customer_min_ticket_amount')
                        "
                        class="error_message"
                      >
                        <span>{{
                          errors.first("customer_min_ticket_amount")
                        }}</span>
                      </p>
                    </div>

                    <div class="col-lg-4 col-xl-3 align-self-center mb-4">
                      <div
                        class="d-flex align-items-center justify-content-center"
                      >
                        {{ $t("offerprice") }}:
                        <div class="input-material-sm mx-2">
                          <input
                            style="text-align: right"
                            v-model="customCategoryOffers.cco_offer_value"
                            type="text"
                            name="customer_offer_value"
                            id="customer_offer_value"
                            v-validate="'required|decimal'"
                          />
                        </div>
                      </div>
                      <p
                        v-if="submitted && errors.has('customer_offer_value')"
                        class="error_message"
                      >
                        <span>{{ errors.first("customer_offer_value") }}</span>
                      </p>
                    </div>

                    <div class="col-lg-3 col-xl-2 align-self-center mb-4">
                      <div class="d-flex align-items-center">
                        <b-form-checkbox
                          class="j-checkbox pb-0 ml-3"
                          v-model="
                            customCategoryOffers.cco_offer_value_is_percentage
                          "
                          unchecked-value="N"
                          value="Y"
                        ></b-form-checkbox>
                        {{ $t("Percentage") }}
                      </div>
                    </div>

                    <div class="col-lg-12 col-xl-4 mb-2">
                      <div class="d-flex align-items-center">
                        {{ $t("MaximumDiscountPerTransaction") }}
                        <div class="input-material-sm mx-2">
                          <input
                            style="text-align: right"
                            v-model="
                              customCategoryOffers.cco_max_discount_amount
                            "
                            type="text"
                            name="customer_max_discount_per_trans"
                            id="customer_max_discount_per_trans"
                            v-validate="'required|numeric'"
                          />
                        </div>
                      </div>
                      <p
                        v-if="
                          submitted &&
                          errors.has('customer_max_discount_per_trans')
                        "
                        class="error_message"
                      >
                        <span>{{
                          errors.first("customer_max_discount_per_trans")
                        }}</span>
                      </p>
                    </div>

                    <!-- <div class="col-lg-6 col-xl-4 align-self-center mb-4">
                    <div class="d-flex align-items-center">
                      {{ $t("offerprice") }}:
                      <div class="input-material-sm mx-2">
                        <input
                          v-model="customCategoryOffers.cco_offer_value"
                          type="text"
                          name="customer_offer_value"
                          id="customer_offer_value"
                          v-validate="'required|decimal'"
                        />
                      </div>
                    </div>
                    <p
                      v-if="submitted && errors.has('customer_offer_value')"
                      class="error_message"
                    >
                      <span>{{ errors.first("customer_offer_value") }}</span>
                    </p>
                  </div> -->

                    <!-- <div class="col-lg-6 col-xl-4 align-self-center mb-4">
                    <div class="d-flex align-items-center">
                      {{ $t("isPercentage") }}
                      <b-form-checkbox
                        class="ml-3"
                        v-model="
                          customCategoryOffers.cco_offer_value_is_percentage
                        "
                        unchecked-value="N"
                        value="Y"
                        switch
                      ></b-form-checkbox>
                    </div>
                  </div> -->

                    <div class="w-100">
                      <div class="col-lg-6 col-xl-12 align-self-center mb-1">
                        <div class="d-flex">
                          <div class="input-material-textarea rounded-10">
                            <textarea
                              v-model="customCategoryOffers.cco_instruction"
                              rows="5"
                              class="rounded-10"
                            ></textarea>
                            <label>{{ $t("specialInstruction") }}</label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!---Bank0ffer-->
                <div
                  class="offer-content-wrapper back_white mt-3 p-3"
                  v-if="selectedOfferType == 'bankOffer'"
                >
                  <div class="row">
                    <div class="col-lg-6 col-xl-6 my-2">
                      <div class="d-flex align-items-center">
                        <custommultiselect
                          v-model="bankOffer.bank_id"
                          :options="activeBankList"
                          :placeholder="$tc('Bank')"
                          label="bank_name"
                          isSingleId="bank_id"
                          :multiple="false"
                          track-by="bank_id"
                          @select="onSelectBank($event)"
                        ></custommultiselect>
                      </div>
                      <p
                        v-if="
                          submitted &&
                          selectedOfferType == 'bankOffer' &&
                          bankOffer.bank_id == null
                        "
                        class="error_message"
                      >
                        <span
                          >{{ $tc("please") }} {{ $tc("selectBank") }}.</span
                        >
                      </p>
                    </div>
                    <div class="col-lg-6 col-xl-6 my-2">
                      <div class="d-flex align-items-center">
                        <custommultiselect
                          v-model="bankOffer.card_id"
                          :options="activeBankCardList"
                          :placeholder="$tc('Card Type')"
                          label="card_type"
                          isSingleId="card_id"
                          :multiple="false"
                          track-by="card_id"
                        ></custommultiselect>
                      </div>
                      <p
                        v-if="
                          submitted &&
                          selectedOfferType == 'bankOffer' &&
                          bankOffer.card_id == null
                        "
                        class="error_message"
                      >
                        <span
                          >{{ $tc("please") }}
                          {{ $tc("selectcardtype") }}.</span
                        >
                      </p>
                    </div>

                    <div class="col-lg-12 col-xl-12 mt-2 mb-3">
                      <div class="d-flex">
                        <div>
                          <b-form-radio
                            class="j-radio"
                            value="weekly"
                            v-model="bankOffer.offerForDuration"
                          >
                            <div>{{ $t("weekly") }} {{ $t("offer") }}</div>
                          </b-form-radio>
                        </div>

                        <div class="ml-3">
                          <b-form-radio
                            class="j-radio mx-4"
                            value="monthly"
                            v-model="bankOffer.offerForDuration"
                          >
                            <div>{{ $t("monthly") }} {{ $t("offer") }}</div>
                          </b-form-radio>
                        </div>

                        <div class="ml-3">
                          <b-form-radio
                            class="j-radio"
                            value="yearly"
                            v-model="bankOffer.offerForDuration"
                          >
                            <div>{{ $t("yearly") }} {{ $t("offer") }}</div>
                          </b-form-radio>
                        </div>
                      </div>
                    </div>

                    <div class="col-lg-6 col-xl-2 align-self-center mb-2">
                      <div
                        class="d-flex align-items-center justify-content-start"
                      >
                        <b-form-checkbox
                          class="j-checkbox pb-0"
                          v-model="bankOffer.bo_offer_value_is_percentage"
                          unchecked-value="N"
                          value="Y"
                        ></b-form-checkbox>

                        {{ $t("isPercentage") }}
                      </div>
                    </div>

                    <div class="col-lg-6 col-xl-3 align-self-center mb-2">
                      <div class="d-flex align-items-center">
                        {{ $tc("redemptionCount") }}
                        <div class="input-material-sm ml-2">
                          <input
                            style="text-align: right"
                            v-model="bankOffer.redemptionCount"
                            type="text"
                            name="bank_redemption_count"
                            id="bank_redemption_count"
                            v-validate="'required|numeric'"
                          />
                        </div>
                      </div>
                      <p
                        v-if="submitted && errors.has('bank_redemption_count')"
                        class="error_message"
                      >
                        <span>{{ errors.first("bank_redemption_count") }}</span>
                      </p>
                    </div>

                    <!-- MAX REDEMPTION PER USER -->
                    <div class="col-lg-6 col-xl-4 align-self-center mb-2">
                      <div class="d-flex align-items-center">
                        {{ $tc("maxRedemptionPerUser") }}
                        <div class="input-material-sm ml-2">
                          <input
                            style="text-align: right"
                            v-model="bankOffer.maxRedemptionPerUser"
                            type="text"
                            name="bank_max_redemption_per_user"
                            id="bank_max_redemption_per_user"
                            v-validate="'required|numeric'"
                          />
                        </div>
                      </div>
                      <p
                        v-if="
                          submitted &&
                          errors.has('bank_max_redemption_per_user')
                        "
                        class="error_message"
                      >
                        <span>{{
                          errors.first("bank_max_redemption_per_user")
                        }}</span>
                      </p>
                    </div>

                    <div class="col-lg-6 col-xl-3 align-self-center mb-2">
                      <div class="row">
                        <div class="">
                          <div class="d-flex align-items-center">
                            {{ $t("offerprice") }}
                            <div class="input-material-sm ml-2">
                              <input
                                style="text-align: right"
                                v-model="bankOffer.bo_offer_value"
                                type="text"
                                name="bank_offer_value"
                                id="bank_offer_value"
                                v-validate="'required|decimal'"
                              />
                            </div>
                          </div>
                          <p
                            v-if="submitted && errors.has('bank_offer_value')"
                            class="error_message"
                          >
                            <span>{{ errors.first("bank_offer_value") }}</span>
                          </p>
                        </div>
                      </div>
                    </div>

                    <div class="col-lg-6 col-xl-12 align-self-center mb-1">
                      <div class="d-flex">
                        <div class="input-material-textarea rounded-10">
                          <textarea
                            v-model="bankOffer.bo_instruction"
                            rows="4"
                            class="rounded-10"
                          ></textarea>
                          <label
                            :class="
                              bankOffer.bo_instruction &&
                              bankOffer.bo_instruction.length > 0
                                ? 'shift-up'
                                : ''
                            "
                            >{{ $t("specialinstructonregardingoffer") }}</label
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!--New Design Ends-->

            <div class v-if="false">
              <ul class="select-offers-list">
                <!-- Buy & Get Free Ticket -->
                <li>
                  <b-form-radio
                    value="buyAndGetFreeTickets"
                    class="j-radio"
                    v-model="selectedOfferType"
                    @change="onChangeOfferType($event)"
                  >
                    <div>{{ $t("buyngetfreeticket") }}</div>
                  </b-form-radio>

                  <div
                    class="offer-content-wrapper pl-0"
                    style="padding-top: 20px"
                    v-if="selectedOfferType == 'buyAndGetFreeTickets'"
                  >
                    <div class="row back_white mx-1 pt-2">
                      <div class="col-lg-12 col-xl-4 mb-2">
                        <div class="d-flex align-items-center">
                          {{ $t("buy") }}
                          <div class="input-material-sm mx-1">
                            <input
                              v-model="buyAndGetFreeTickets.oc_buy_no_of_ticket"
                              type="text"
                              name="buy_value"
                              id="buy_value"
                              v-validate="
                                selectedOfferType == 'buyAndGetFreeTickets'
                                  ? 'required|numeric'
                                  : ''
                              "
                            />
                          </div>
                          {{ $t("get") }}
                          <div class="input-material-sm mx-2">
                            <input
                              v-model="buyAndGetFreeTickets.oc_get_free_ticket"
                              type="text"
                              name="get_value"
                              id="get_value"
                              v-validate="'required|numeric'"
                            />
                          </div>
                          {{ $t("ofticketsfree") }}
                        </div>
                        <p
                          v-if="
                            (submitted && errors.has('buy_value')) ||
                            (submitted && errors.has('get_value'))
                          "
                          class="error_message"
                        >
                          <span>{{
                            errors.first("buy_value") ||
                            errors.first("get_value")
                          }}</span>
                        </p>
                      </div>

                      <div class="col-lg-12 col-xl-4 mb-2">
                        <div
                          class="
                            d-flex
                            align-items-center
                            justify-content-center
                          "
                        >
                          {{ $tc("minTicketAmount") }}
                          <div class="input-material-sm mx-2">
                            <input
                              v-model="buyAndGetFreeTickets.oc_min_ticket_price"
                              type="text"
                              name="min_ticket_amount"
                              id="min_ticket_amount"
                              v-validate="'required|decimal'"
                            />
                          </div>
                        </div>
                        <p
                          v-if="submitted && errors.has('min_ticket_amount')"
                          class="error_message"
                        >
                          <span>{{ errors.first("min_ticket_amount") }}</span>
                        </p>
                      </div>

                      <div class="col-lg-12 col-xl-4 mb-2">
                        <div class="d-flex align-items-center">
                          {{ $t("maxfreeticketpertransaction") }}
                          <div class="input-material-sm mx-2">
                            <input
                              v-model="
                                buyAndGetFreeTickets.oc_max_no_of_ticket_per_transaction
                              "
                              type="text"
                              name="max_ticket"
                              id="max_ticket"
                              v-validate="'required|numeric'"
                            />
                          </div>
                        </div>
                        <p
                          v-if="submitted && errors.has('max_ticket')"
                          class="error_message"
                        >
                          <span>{{ errors.first("max_ticket") }}</span>
                        </p>
                      </div>

                      <!-- <div class="col-lg-12 col-xl-12 align-self-center mb-4" style="height:38px;">
                    <div class="d-flex align-items-center">
                      {{ $t('cancombinewithotheroffers') }}
                      <b-form-checkbox
                        class="ml-3"
                        v-model="buyAndGetFreeTickets.oc_combine_with_other_offers"
                        unchecked-value="N"
                        value="Y"
                        switch
                      ></b-form-checkbox>
                    </div>
                  </div> 
                  <div class="col-lg-12 col-xl-12 align-self-center mb-4">
                    <b-collapse v-model="buyAndGetFreeTickets.oc_combine_with_other_offers === 'Y'">
                      <div class="d-flex align-items-center">
                        <b-form-select
                          class="select-curve w-75"
                          :options="currentlyActiveOffers"
                          v-model="buyAndGetFreeTickets.selectedCombineoffer"
                        ></b-form-select>
                      </div>
                    </b-collapse>
                  </div>-->
                    </div>
                  </div>
                </li>

                <!-- DISCOUNT -->
                <li>
                  <b-form-radio
                    class="j-radio"
                    value="discount"
                    v-model="selectedOfferType"
                  >
                    <div>{{ $t("discounts") }}</div>
                  </b-form-radio>

                  <div
                    class="offer-content-wrapper pt-3 pl-0"
                    v-if="selectedOfferType == 'discount'"
                  >
                    <div class="row pl-0 back_white mx-1 pt-2">
                      <div
                        class="col-12 pt-2 pb-0"
                        v-for="(
                          discountList, discountListIndex
                        ) in discountLists"
                        :key="discountListIndex"
                      >
                        <div class="row">
                          <div class="col-lg-10 col-xl-11">
                            <div class="row">
                              <div
                                class="
                                  col-lg-12 col-xl-6
                                  align-self-center
                                  mb-2
                                "
                              >
                                <div class="d-flex align-items-center">
                                  {{ $t("buy") }}
                                  <div class="input-material-sm mx-1">
                                    <input
                                      style="text-align: right"
                                      name="discount_buy_value"
                                      id="discount_buy_value"
                                      v-validate="'required|numeric'"
                                      type="text"
                                      v-model="discountList.oc_buy_no_of_ticket"
                                    />
                                  </div>
                                  {{ $t("ticket_fnbitem") }}
                                  <div class="input-material-sm mx-2">
                                    <input
                                      style="text-align: right"
                                      type="text"
                                      name="discount_get_value"
                                      id="discount_get_value"
                                      v-validate="'required|numeric'"
                                      v-model="discountList.oc_discount_value"
                                    />
                                  </div>
                                </div>
                                <p
                                  v-if="
                                    (submitted &&
                                      errors.has('discount_buy_value')) ||
                                    (submitted &&
                                      errors.has('discount_get_value'))
                                  "
                                  class="error_message"
                                >
                                  <span>{{
                                    errors.first("discount_buy_value") ||
                                    errors.first("discount_get_value")
                                  }}</span>
                                </p>
                              </div>
                              <div
                                class="col-lg-6 col-xl-2 align-self-center mb-2"
                              >
                                <div class="d-flex align-items-center">
                                  <b-form-checkbox
                                    class="ml-3 j-checkbox pb-0"
                                    v-model="
                                      discountList.oc_discount_value_is_percentage
                                    "
                                    unchecked-value="N"
                                    value="Y"
                                  ></b-form-checkbox>
                                  {{ $t("Percentage") }}
                                </div>
                              </div>
                              <div
                                class="
                                  col-lg-12 col-xl-4
                                  align-self-center
                                  mb-lg-2 mb-xl-2
                                "
                              >
                                <div class="d-flex align-items-center">
                                  {{ $t("maxdiscountpertransaction") }}
                                  <div class="input-material-sm mx-2">
                                    <input
                                      style="text-align: right"
                                      type="text"
                                      name="max_discount_per_trans"
                                      id="max_discount_per_trans"
                                      v-validate="'required|numeric'"
                                      v-model="
                                        discountList.oc_max_discount_amount
                                      "
                                    />
                                  </div>
                                </div>
                                <p
                                  v-if="
                                    submitted &&
                                    errors.has('max_discount_per_trans')
                                  "
                                  class="error_message"
                                >
                                  <span>{{
                                    errors.first("max_discount_per_trans")
                                  }}</span>
                                </p>
                              </div>
                              <!-- <div
                            class="col-lg-12 col-xl-4 align-self-center mb-lg-4 mb-xl-0"
                            style="height:38px;"
                          >
                            <div class="d-flex align-items-center h-100">
                              {{ $t('cancombinewithotheroption') }}
                              <b-form-checkbox
                                class="ml-3"
                                v-model="discountList.canCombineOtherOffers"
                                unchecked-value="N"
                                value="Y"
                                switch
                              ></b-form-checkbox>
                            </div>
                          </div>
                          <div class="col-lg-6 col-xl-4 align-self-center">
                            <b-collapse v-model="discountList.canCombineOtherOffers === 'Y'">
                              <div class="d-flex align-items-center">
                                <b-form-select
                                  class="select-curve w-75"
                                  :options="currentlyActiveOffers"
                                  v-model="discountList.selectedCombinedOffer"
                                ></b-form-select>
                              </div>
                            </b-collapse>
                          </div>-->
                            </div>
                          </div>
                          <div
                            class="
                              col-lg-2 col-xl-1
                              d-flex
                              justify-content-center
                              align-items-center
                            "
                            v-if="false"
                          >
                            <button
                              class="btn-transparent mb-3"
                              @click="addDiscount()"
                              v-if="discountListIndex == 0"
                            >
                              <img
                                src="@/assets/img/icons/plus.svg"
                                height="35"
                                width="35"
                              />
                            </button>

                            <!-- <button
                          v-if="discountListIndex === 0 && discountLists.length !== 1"
                          class="btn-transparent mb-3"
                          @click="removeDiscount(discountListIndex)"
                        >
                          <img src="@/assets/img/icons/minus.svg" height="35" width="35" />
                        </button>-->

                            <button
                              v-if="discountListIndex !== 0"
                              class="btn-transparent mb-3"
                              @click="removeDiscount(discountListIndex)"
                            >
                              <img
                                src="@/assets/img/icons/minus.svg"
                                height="35"
                                width="35"
                              />
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>

                <!-- Buy And Get Como -->
                <li>
                  <b-form-radio
                    value="buyAndGetCombo"
                    class="j-radio"
                    v-model="selectedOfferType"
                  >
                    <div>{{ $t("buyandgetcombo") }}</div>
                  </b-form-radio>

                  <div
                    class="offer-content-wrapper"
                    v-if="selectedOfferType == 'buyAndGetCombo'"
                  >
                    <div class="row">
                      <div class="col-lg-12 col-xl-12 align-self-center mb-4">
                        <div class="d-flex">
                          {{ $t("combinewith") }}:
                          <b-form-radio
                            value="fAndb"
                            class="j-radio ml-4"
                            v-model="buyAndGetCombo.offerApplicableAt"
                          >
                            <div>F&amp;B</div>
                          </b-form-radio>
                          <b-form-radio
                            value="boxOffice"
                            class="j-radio ml-3"
                            v-model="buyAndGetCombo.offerApplicableAt"
                          >
                            <div>{{ $t("boxoffice") }}</div>
                          </b-form-radio>
                        </div>
                      </div>
                      <div
                        class="col-12"
                        v-if="buyAndGetCombo.offerApplicableAt === 'fAndb'"
                      >
                        <div class="row">
                          <div class="col-lg-12 col-xl-12">
                            <div class="row mx-0 align-items-center">
                              <div class="mb-2">
                                <span class="text-nowrap">{{ $t("buy") }}</span>
                              </div>
                              <div class="input-material-sm mx-1">
                                <input
                                  v-model="
                                    buyAndGetCombo.F_And_B.oc_buy_item_count
                                  "
                                  type="text"
                                  name="buy_fnb_combo"
                                  id="buy_fnb_combo"
                                  v-validate="'required|numeric'"
                                />
                              </div>

                              <div class="multiselect-sm select-curve mx-2">
                                <custommultiselect
                                  v-model="
                                    buyAndGetCombo.F_And_B.oc_buy_item_id
                                  "
                                  :options="fnbItems"
                                  :placeholder="$tc('SelectFBItem')"
                                  label="item_name"
                                  isSingleId="item_id"
                                  :multiple="false"
                                  track-by="item_id"
                                ></custommultiselect>
                              </div>
                              <span class="text-nowrap">{{ $t("get") }}</span>

                              <div class="input-material-sm mx-2">
                                <input
                                  v-model="
                                    buyAndGetCombo.F_And_B.oc_get_item_count
                                  "
                                  type="text"
                                  name="get_fnb_combo"
                                  id="get_fnb_combo"
                                  v-validate="'required|numeric'"
                                />
                              </div>

                              <div class="multiselect-sm select-curve mx-2">
                                <custommultiselect
                                  v-model="
                                    buyAndGetCombo.F_And_B.oc_get_item_id
                                  "
                                  :options="fnbItems"
                                  :placeholder="$tc('SelectFBItem')"
                                  label="item_name"
                                  isSingleId="item_id"
                                  :multiple="false"
                                  track-by="item_id"
                                ></custommultiselect>
                              </div>
                              <div class="d-flex align-items-center">
                                <span class="text-nowrap">Free</span>
                                <b-form-checkbox
                                  class="ml-3"
                                  v-model="
                                    buyAndGetCombo.F_And_B.oc_is_combo_free
                                  "
                                  unchecked-value="N"
                                  value="Y"
                                  switch
                                ></b-form-checkbox>
                              </div>

                              <div
                                v-if="
                                  buyAndGetCombo.F_And_B.oc_is_combo_free ===
                                  'N'
                                "
                                style="display: flex"
                              >
                                <div class="d-flex align-items-center ml-3">
                                  <span class="text-nowrap"
                                    >&nbsp;{{ $t("offer") }}
                                    {{ $t("value") }}</span
                                  >
                                  <div class="input-material-sm mx-2">
                                    <input
                                      type="text"
                                      name="free_combo_offer_value"
                                      id="free_combo_offer_value"
                                      v-validate="'required|decimal'"
                                      v-model="
                                        buyAndGetCombo.F_And_B.oc_discount_value
                                      "
                                    />
                                  </div>
                                </div>
                                <div class="d-flex align-items-center">
                                  {{ $t("isPercentage") }}
                                  <b-form-checkbox
                                    class="ml-3"
                                    v-model="
                                      buyAndGetCombo.F_And_B
                                        .oc_discount_value_is_percentage
                                    "
                                    unchecked-value="N"
                                    value="Y"
                                    switch
                                  ></b-form-checkbox>
                                </div>
                              </div>
                            </div>
                            <p
                              v-if="
                                (submitted && errors.has('buy_fnb_combo')) ||
                                errors.has('get_fnb_combo') ||
                                (buyAndGetCombo.F_And_B.oc_is_combo_free ===
                                  'N' &&
                                  errors.has('free_combo_offer_value'))
                              "
                              class="error_message"
                            >
                              <span>{{
                                errors.first("buy_fnb_combo") ||
                                errors.first("get_fnb_combo") ||
                                errors.first("free_combo_offer_value")
                              }}</span>
                            </p>
                            <p
                              v-else-if="
                                submitted &&
                                buyAndGetCombo.F_And_B.oc_buy_item_count !=
                                  null &&
                                buyAndGetCombo.F_And_B.oc_buy_item_id == null
                              "
                              class="error_message"
                            >
                              <span>Please select F&B item for Buy.</span>
                            </p>
                            <p
                              v-else-if="
                                submitted &&
                                buyAndGetCombo.F_And_B.oc_get_item_count !=
                                  null &&
                                buyAndGetCombo.F_And_B.oc_get_item_id == null
                              "
                              class="error_message"
                            >
                              <span>Please select F&B item for Get.</span>
                            </p>
                          </div>
                        </div>
                      </div>

                      <div
                        class="col-12"
                        v-if="buyAndGetCombo.offerApplicableAt === 'boxOffice'"
                      >
                        <div class="row">
                          <div class="col-lg-12 col-xl-12">
                            <div class="row mx-0 align-items-center">
                              <div>
                                <span class="text-nowrap">{{ $t("buy") }}</span>
                              </div>
                              <div class="input-material-sm mx-1">
                                <input
                                  v-model="
                                    buyAndGetCombo.boxOffice.oc_buy_no_of_ticket
                                  "
                                  type="text"
                                  name="buy_bo_combo"
                                  id="buy_bo_combo"
                                  v-validate="'required|numeric'"
                                />
                              </div>

                              <span class="text-nowrap"
                                >{{ $t("tickets") }}&nbsp;{{ $t("get") }}</span
                              >

                              <div class="input-material-sm mx-2">
                                <!-- <input v-model="buyAndGetCombo.boxOffice.getCount" type="number" /> -->
                                <div
                                  class="multiselect-sm select-curve mx-2"
                                  style="min-width: 180px"
                                >
                                  <custommultiselect
                                    v-model="
                                      buyAndGetCombo.boxOffice.oc_get_item_id
                                    "
                                    :options="fnbItems"
                                    :placeholder="$tc('SelectFBItem')"
                                    label="item_name"
                                    isSingleId="item_id"
                                    :multiple="false"
                                    track-by="item_id"
                                  ></custommultiselect>
                                </div>
                              </div>
                              <!-- <span class="text-nowrap">{{ $t('tickets') }}&nbsp;&nbsp;</span> -->
                              <div
                                class="d-flex align-items-center"
                                style="margin-left: 8rem"
                              >
                                <span class="text-nowrap">{{
                                  $t("free")
                                }}</span>
                                <b-form-checkbox
                                  class="ml-1"
                                  v-model="
                                    buyAndGetCombo.boxOffice.oc_is_combo_free
                                  "
                                  unchecked-value="N"
                                  value="Y"
                                  switch
                                ></b-form-checkbox>
                              </div>
                              <div
                                v-if="
                                  buyAndGetCombo.boxOffice.oc_is_combo_free ===
                                  'N'
                                "
                                style="display: flex"
                              >
                                <div class="d-flex align-items-center ml-5">
                                  <span class="text-nowrap"
                                    >&nbsp;{{ $t("offer") }}
                                    {{ $t("value") }}</span
                                  >
                                  <div class="input-material-sm mx-2">
                                    <input
                                      type="text"
                                      name="free_combo_bo_offer_value"
                                      id="free_combo_bo_offer_value"
                                      v-validate="'required|decimal'"
                                      v-model="
                                        buyAndGetCombo.boxOffice
                                          .oc_discount_value
                                      "
                                    />
                                  </div>
                                </div>
                                <div class="d-flex align-items-center">
                                  {{ $t("isPercentage") }}
                                  <b-form-checkbox
                                    class="ml-3"
                                    v-model="
                                      buyAndGetCombo.boxOffice
                                        .oc_discount_value_is_percentage
                                    "
                                    unchecked-value="N"
                                    value="Y"
                                    switch
                                  ></b-form-checkbox>
                                </div>
                              </div>
                            </div>
                            <p
                              v-if="
                                (submitted && errors.has('buy_bo_combo')) ||
                                (buyAndGetCombo.boxOffice.oc_is_combo_free ===
                                  'N' &&
                                  errors.has('free_combo_bo_offer_value'))
                              "
                              class="error_message"
                            >
                              <span>{{
                                errors.first("buy_bo_combo") ||
                                errors.first("free_combo_bo_offer_value")
                              }}</span>
                            </p>
                            <p
                              v-else-if="
                                submitted &&
                                buyAndGetCombo.boxOffice.oc_buy_no_of_ticket !=
                                  null &&
                                buyAndGetCombo.boxOffice.oc_get_item_id == null
                              "
                              class="error_message"
                            >
                              <span>Please select F&B item for get.</span>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>

                <!-- <li>
              <b-form-radio value="buyAndGetCombo" class="j-radio" v-model="selectedOfferType">
                <div>{{ $t('buyandgetcombo') }}</div>
              </b-form-radio>

              <div class="offer-content-wrapper" v-if="selectedOfferType == 'buyAndGetCombo'">
                <div class="row">
                  <div class="col-lg-12 col-xl-12 align-self-center mb-4">
                    <div class="d-flex">
                      <strong>1.&nbsp;</strong>
                      {{ $t('offerapplicableat') }}:
                      <b-form-radio
                        value="fAndb"
                        class="j-radio ml-4"
                        v-model="buyAndGetCombo.offerApplicableAt"
                      >
                        <div>F&amp;B</div>
                      </b-form-radio>
                      <b-form-radio
                        value="boxOffice"
                        class="j-radio ml-3"
                        v-model="buyAndGetCombo.offerApplicableAt"
                      >
                        <div>{{ $t('boxoffice') }}</div>
                      </b-form-radio>
                    </div>
                  </div>
                  <div class="col-12" v-if="buyAndGetCombo.offerApplicableAt == 'fAndb'">
                    <div class="row">
                      <div class="col-lg-12 col-xl-12">
                        <div class="row mx-0 align-items-center">
                          <div class="mb-2">
                            <strong>2.&nbsp;</strong>
                            <span class="text-nowrap">{{ $t('buy') }}</span>
                          </div>
                          <b-form-select
                            class="select-curve mx-2 mb-2"
                            style="width:140px"
                            :options="numbersList"
                            v-model="selectedNumber"
                          ></b-form-select>
                          <b-form-select
                            class="select-curve mx-2"
                            style="width:300px"
                            :options="fnbItemsList"
                            v-model="selectedFnbItems"
                          ></b-form-select>
                          <span class="text-nowrap">{{ $t('get') }}</span>
                          <b-form-select
                            class="select-curve mx-2"
                            style="width:150px"
                            :options="applyBngcAtList"
                            v-model="applyBngcAt"
                          ></b-form-select>
                          <b-form-select
                            class="select-curve mx-2"
                            style="width:140px"
                            :options="numbersList"
                            v-model="selectedNumber"
                          ></b-form-select>
                          <b-form-select
                            class="select-curve mx-2"
                            style="width:300px"
                            :options="fnbItemsList"
                            v-model="selectedFnbItems"
                          ></b-form-select>
                          <div class="d-flex align-items-center">
                            <span class="text-nowrap">Free</span>
                            <b-form-checkbox switch v-model="isPercentage" class="ml-3"></b-form-checkbox>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </li>-->

                <!-- Customer Category Offer -->
                <li>
                  <b-form-radio
                    class="j-radio"
                    value="customCategoryOffers"
                    v-model="selectedOfferType"
                  >
                    <div>{{ $t("customercategoryoffer") }}</div>
                  </b-form-radio>

                  <div
                    class="offer-content-wrapper"
                    v-if="selectedOfferType == 'customCategoryOffers'"
                  >
                    <div class="row">
                      <div class="col-lg-8 align-self-center mb-4">
                        <div class="d-flex">
                          <b-form-radio
                            v-for="(
                              Item, ItmeIndex
                            ) in customerOffersCategories"
                            :key="ItmeIndex"
                            @change="onChangeCustomerCategory"
                            v-model="
                              customCategoryOffers.booking_user_category_id
                            "
                            :value="Item.buc_id"
                            class="j-radio col"
                          >
                            <div>{{ $t(Item.buc_category_name) }}&nbsp;</div>
                          </b-form-radio>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div
                        v-if="
                          String(
                            customCategoryOffers.booking_user_category_id
                          ) === String(2) ||
                          String(
                            customCategoryOffers.booking_user_category_id
                          ) === String(4)
                        "
                        class="col-lg-12 col-xl-12 align-self-center mb-4"
                      >
                        <div class="d-flex align-items-center">
                          <div class="multiselect-sm">
                            <custommultiselect
                              v-model="customCategoryOffers.institution_id"
                              :options="institutionList"
                              :placeholder="$tc('selectInstitute')"
                              label="institution_name"
                              isSingleId="institution_id"
                              :multiple="false"
                              track-by="institution_id"
                            ></custommultiselect>
                          </div>
                          <p
                            v-if="
                              submitted &&
                              customCategoryOffers.institution_id == null
                            "
                            class="error_message"
                          >
                            <span>{{ $t("pleaseSelectInstitution") }}</span>
                          </p>
                        </div>
                      </div>

                      <div class="col-lg-8 align-self-center mb-4">
                        <div class="d-flex align-items-center">
                          <div class="mr-3 text-nowrap">
                            {{ $t("validateby") }}:
                          </div>
                          <div class="multiselect">
                            <custommultiselect
                              v-model="customCategoryOffers.validate_doc_id"
                              :options="verificationList"
                              :placeholder="$tc('selectVerificationid')"
                              label="vd_document_name"
                              :multiple="true"
                              track-by="vd_id"
                            ></custommultiselect>
                          </div>
                          <p
                            v-if="
                              submitted &&
                              selectedOfferType == 'customCategoryOffers' &&
                              customCategoryOffers.validate_doc_id == null
                            "
                            class="error_message"
                          >
                            <span
                              >{{ $t("please") }}
                              {{ $t("selectVerificationid") }}</span
                            >
                          </p>
                        </div>
                      </div>

                      <div class="col-lg-5 col-xl-5 mb-4">
                        <div class="d-flex align-items-center">
                          {{ $tc("minimumTicketAmount") }}
                          <div class="input-material-sm mx-2">
                            <input
                              v-model="
                                customCategoryOffers.cco_min_ticket_amount
                              "
                              type="text"
                              name="customer_min_ticket_amount"
                              id="customer_min_ticket_amount"
                              v-validate="'required|decimal'"
                            />
                          </div>
                        </div>
                        <p
                          v-if="
                            submitted &&
                            errors.has('customer_min_ticket_amount')
                          "
                          class="error_message"
                        >
                          <span>{{
                            errors.first("customer_min_ticket_amount")
                          }}</span>
                        </p>
                      </div>

                      <div class="col-lg-4 col-xl-4 align-self-center mb-4">
                        <div class="d-flex align-items-center">
                          {{ $t("offerprice") }}:
                          <div class="input-material-sm mx-2">
                            <input
                              v-model="customCategoryOffers.cco_offer_value"
                              type="text"
                              name="customer_offer_value"
                              id="customer_offer_value"
                              v-validate="'required|decimal'"
                            />
                          </div>
                        </div>
                        <p
                          v-if="submitted && errors.has('customer_offer_value')"
                          class="error_message"
                        >
                          <span>{{
                            errors.first("customer_offer_value")
                          }}</span>
                        </p>
                      </div>

                      <div class="col-lg-3 col-xl-3 align-self-center mb-4">
                        <div class="d-flex align-items-center">
                          {{ $t("isPercentage") }}
                          <b-form-checkbox
                            class="ml-3"
                            v-model="
                              customCategoryOffers.cco_offer_value_is_percentage
                            "
                            unchecked-value="N"
                            value="Y"
                            switch
                          ></b-form-checkbox>
                        </div>
                      </div>

                      <div class="col-lg-12 col-xl-12 mb-4">
                        <div class="d-flex align-items-center">
                          {{ $t("MaximumDiscountPerTransaction") }}
                          <div class="input-material-sm mx-2">
                            <input
                              v-model="
                                customCategoryOffers.cco_max_discount_amount
                              "
                              type="text"
                              name="customer_max_discount_per_trans"
                              id="customer_max_discount_per_trans"
                              v-validate="'required|numeric'"
                            />
                          </div>
                        </div>
                        <p
                          v-if="
                            submitted &&
                            errors.has('customer_max_discount_per_trans')
                          "
                          class="error_message"
                        >
                          <span>{{
                            errors.first("customer_max_discount_per_trans")
                          }}</span>
                        </p>
                      </div>

                      <!-- <div class="col-lg-6 col-xl-4 align-self-center mb-4">
                    <div class="d-flex align-items-center">
                      {{ $t("offerprice") }}:
                      <div class="input-material-sm mx-2">
                        <input
                          v-model="customCategoryOffers.cco_offer_value"
                          type="text"
                          name="customer_offer_value"
                          id="customer_offer_value"
                          v-validate="'required|decimal'"
                        />
                      </div>
                    </div>
                    <p
                      v-if="submitted && errors.has('customer_offer_value')"
                      class="error_message"
                    >
                      <span>{{ errors.first("customer_offer_value") }}</span>
                    </p>
                  </div> -->

                      <!-- <div class="col-lg-6 col-xl-4 align-self-center mb-4">
                    <div class="d-flex align-items-center">
                      {{ $t("isPercentage") }}
                      <b-form-checkbox
                        class="ml-3"
                        v-model="
                          customCategoryOffers.cco_offer_value_is_percentage
                        "
                        unchecked-value="N"
                        value="Y"
                        switch
                      ></b-form-checkbox>
                    </div>
                  </div> -->

                      <div class="w-100">
                        <div class="col-lg-6 col-xl-8 align-self-center mb-4">
                          <div class="d-flex">
                            <div class="input-material-textarea rounded-10">
                              <textarea
                                v-model="customCategoryOffers.cco_instruction"
                                rows="5"
                                class="rounded-10"
                              ></textarea>
                              <label>{{ $t("specialInstruction") }}</label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>

                <!-- Bank Offer -->
                <li>
                  <b-form-radio
                    class="j-radio"
                    value="bankOffer"
                    v-model="selectedOfferType"
                  >
                    <div>{{ $t("bank") }} {{ $t("offer") }}</div>
                  </b-form-radio>

                  <div
                    class="offer-content-wrapper"
                    v-if="selectedOfferType == 'bankOffer'"
                  >
                    <div class="row">
                      <div class="col-lg-6 col-xl-6 mb-4">
                        <div class="d-flex align-items-center">
                          <custommultiselect
                            v-model="bankOffer.bank_id"
                            :options="activeBankList"
                            :placeholder="$tc('selectBank')"
                            label="bank_name"
                            isSingleId="bank_id"
                            :multiple="false"
                            track-by="bank_id"
                            @select="onSelectBank($event)"
                          ></custommultiselect>
                        </div>
                        <p
                          v-if="
                            submitted &&
                            selectedOfferType == 'bankOffer' &&
                            bankOffer.bank_id == null
                          "
                          class="error_message"
                        >
                          <span
                            >{{ $tc("please") }} {{ $tc("selectBank") }}.</span
                          >
                        </p>
                      </div>
                      <div class="col-lg-6 col-xl-6 mb-4">
                        <div class="d-flex align-items-center">
                          <custommultiselect
                            v-model="bankOffer.card_id"
                            :options="activeBankCardList"
                            :placeholder="$tc('selectCardType')"
                            label="card_type"
                            isSingleId="card_id"
                            :multiple="false"
                            track-by="card_id"
                          ></custommultiselect>
                        </div>
                        <p
                          v-if="
                            submitted &&
                            selectedOfferType == 'bankOffer' &&
                            bankOffer.card_id == null
                          "
                          class="error_message"
                        >
                          <span
                            >{{ $tc("please") }}
                            {{ $tc("selectcardtype") }}.</span
                          >
                        </p>
                      </div>

                      <div class="col-lg-12 col-xl-12 mb-4">
                        <div class="d-flex">
                          <div>
                            <b-form-radio
                              class="j-radio"
                              value="weekly"
                              v-model="bankOffer.offerForDuration"
                            >
                              <div>{{ $t("weekly") }} {{ $t("offer") }}</div>
                            </b-form-radio>
                          </div>

                          <div class="ml-3">
                            <b-form-radio
                              class="j-radio mx-4"
                              value="monthly"
                              v-model="bankOffer.offerForDuration"
                            >
                              <div>{{ $t("monthly") }} {{ $t("offer") }}</div>
                            </b-form-radio>
                          </div>

                          <div class="ml-3">
                            <b-form-radio
                              class="j-radio"
                              value="yearly"
                              v-model="bankOffer.offerForDuration"
                            >
                              <div>{{ $t("yearly") }} {{ $t("offer") }}</div>
                            </b-form-radio>
                          </div>
                        </div>
                      </div>

                      <div class="col-lg-6 col-xl-4 align-self-center mb-4">
                        <div class="d-flex align-items-center">
                          {{ $t("isPercentage") }}
                          <b-form-checkbox
                            class="ml-3"
                            v-model="bankOffer.bo_offer_value_is_percentage"
                            unchecked-value="N"
                            value="Y"
                            switch
                          ></b-form-checkbox>
                        </div>
                      </div>

                      <div class="col-lg-6 col-xl-4 align-self-center mb-4">
                        <div class="d-flex align-items-center">
                          {{ $tc("redemptionCount") }}
                          <div class="input-material-sm ml-2">
                            <input
                              v-model="bankOffer.redemptionCount"
                              type="text"
                              name="bank_redemption_count"
                              id="bank_redemption_count"
                              v-validate="'required|numeric'"
                            />
                          </div>
                        </div>
                        <p
                          v-if="
                            submitted && errors.has('bank_redemption_count')
                          "
                          class="error_message"
                        >
                          <span>{{
                            errors.first("bank_redemption_count")
                          }}</span>
                        </p>
                      </div>

                      <!-- MAX REDEMPTION PER USER -->
                      <div class="col-lg-6 col-xl-4 align-self-center mb-4">
                        <div class="d-flex align-items-center">
                          {{ $tc("maxRedemptionPerUser") }}
                          <div class="input-material-sm ml-2">
                            <input
                              v-model="bankOffer.maxRedemptionPerUser"
                              type="text"
                              name="bank_max_redemption_per_user"
                              id="bank_max_redemption_per_user"
                              v-validate="'required|numeric'"
                            />
                          </div>
                        </div>
                        <p
                          v-if="
                            submitted &&
                            errors.has('bank_max_redemption_per_user')
                          "
                          class="error_message"
                        >
                          <span>{{
                            errors.first("bank_max_redemption_per_user")
                          }}</span>
                        </p>
                      </div>

                      <div class="col-lg-6 col-xl-4 align-self-center mb-4">
                        <div class="row">
                          <div class="col-lg-6 col-xl-6 align-self-center mb-4">
                            <div class="d-flex align-items-center">
                              {{ $t("offerprice") }}
                              <div class="input-material-sm ml-2">
                                <input
                                  v-model="bankOffer.bo_offer_value"
                                  type="text"
                                  name="bank_offer_value"
                                  id="bank_offer_value"
                                  v-validate="'required|decimal'"
                                />
                              </div>
                            </div>
                            <p
                              v-if="submitted && errors.has('bank_offer_value')"
                              class="error_message"
                            >
                              <span>{{
                                errors.first("bank_offer_value")
                              }}</span>
                            </p>
                          </div>
                        </div>
                      </div>

                      <div class="col-lg-6 col-xl-6 align-self-center mb-4">
                        <div class="d-flex">
                          <div class="input-material-textarea rounded-10">
                            <textarea
                              v-model="bankOffer.bo_instruction"
                              rows="4"
                              class="rounded-10"
                            ></textarea>
                            <label
                              :class="
                                bankOffer.bo_instruction &&
                                bankOffer.bo_instruction.length > 0
                                  ? 'shift-up'
                                  : ''
                              "
                              >{{
                                $t("specialinstructonregardingoffer")
                              }}</label
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </b-collapse>
      </section>

      <section class="mb-2">
        <div
          class="
            section-title
            mb-3
            d-flex
            justify-content-between
            section-border section-border
          "
          style="padding: 6px; align-items: center"
          v-b-toggle.outlet
        >
          <span class="fs"> {{ $t("redemptionOutlet") }}</span>
          <button type="button" class="btn-transparent chevron">
            <img
              src="@/assets/img/icons/primary/chevron-down.svg"
              height="24"
              width="24"
            />
          </button>
        </div>
        <b-collapse id="outlet" v-model="sectionCollapse.outlet">
          <div class="new-border rounded-10 p-3 back mb-2">
            <!--div class="section-title text-uppercase mb-3" style="font-size: 20px">
          {{ $t("redemptionOutlet") }}
        </div-->
            <div class="row">
              <!-- {{ RedemptionOutlet.offer_redeem_at_online }} -->
              <div class="col-lg-4 col-xl-3 align-self-center">
                <div class="d-flex align-items-center">
                  <b-form-checkbox
                    :disabled="OffersAndPromotion.is_employee_offer == 'Y'"
                    v-model="RedemptionOutlet.offer_redeem_at_online"
                    unchecked-value="N"
                    value="Y"
                    class="j-checkbox pb-0"
                  ></b-form-checkbox>
                  <div class="mr-2">{{ $t("canavailonline") }}</div>
                </div>
              </div>
              <!-- {{ RedemptionOutlet.offer_redeem_at_boxoffice }} -->
              <div class="col-lg-4 col-xl-3 align-self-center">
                <div class="d-flex align-items-center">
                  <b-form-checkbox
                    v-model="RedemptionOutlet.offer_redeem_at_boxoffice"
                    unchecked-value="N"
                    value="Y"
                    class="j-checkbox pb-0"
                  ></b-form-checkbox>
                  <div class="mr-2">{{ $t("availatboxoffice") }}</div>
                </div>
              </div>
              <!-- {{ RedemptionOutlet.offer_redeem_at_concession}} -->
              <div class="col-lg-4 col-xl-3 align-self-center">
                <div class="d-flex align-items-center">
                  <b-form-checkbox
                    :disabled="
                      [
                        'buyAndGetFreeTickets',
                        'fixedPriceTicketFnb',
                        'buyAndgetOffOnAnother',
                      ].includes(selectedOfferType)
                    "
                    v-model="RedemptionOutlet.offer_redeem_at_concession"
                    unchecked-value="N"
                    value="Y"
                    class="j-checkbox pb-0"
                  ></b-form-checkbox>
                  <div class="mr-2">
                    {{ $t("availatconcession") }} <br />
                    <span class="text-muted fs-12">{{
                      [
                        "buyAndGetFreeTickets",
                        "fixedPriceTicketFnb",
                        "buyAndgetOffOnAnother",
                      ].includes(selectedOfferType)
                        ? "(Not Applicable)"
                        : ""
                    }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mx-0 mt-3" v-if="false">
              <div class="col-lg-12 mb-2 pl-0">
                <div class="d-flex align-items-center">
                  <b-form-radio
                    value="net_amount"
                    class="j-radio"
                    v-model="RedemptionOutlet.offer_applicable_on"
                  >
                    <div>
                      <span>{{ $tc("offerApplicableOnNetAmount") }}</span>
                    </div>
                  </b-form-radio>
                  <strong class="mx-3">OR</strong>

                  <b-form-radio
                    value="gross_amount"
                    class="j-radio"
                    v-model="RedemptionOutlet.offer_applicable_on"
                  >
                    <div>
                      <span>{{ $tc("offerApplicableOnGrossAmount") }}</span>
                    </div>
                  </b-form-radio>
                </div>
              </div>
            </div>
          </div>
        </b-collapse>
      </section>

      <!-- Signage Section -->
      <section class="mb-2">
        <div
          class="
              section-title
              mb-3
              d-flex
              justify-content-between
              section-border section-border
            "
          style="padding:6px;align-items:center"
          v-b-toggle.signage
        >
          <span class="fs">Signage Images</span>

          <button type="button" class="btn-transparent chevron">
            <img
              src="@/assets/img/icons/primary/chevron-down.svg"
              height="24"
              width="24"
            />
          </button>
        </div>

        <b-collapse id="signage" class="mt-2" v-model="sectionCollapse.signage">
          <div class="">
            <!-- Movie Scenes -->

            <div class="col-md-12 new-border rounded-10 back">
              <div class="col-md-12 my-2">
                <div class="row">
                  <div class="col-11">
                    <div class="row">
                      <div
                        v-for="(signageItem,
                        signageItemIndex) in signageContainer"
                        :key="signageItemIndex + 'SignageContainer'"
                        class="col-md-12 mb-3"
                      >
                        <div class="row">
                          <div class="col-3 pl-0">
                            <div class="input-material mt-2">
                              <input
                                type="number"
                                v-model="signageItem.width"
                                :disabled="signageItemIndex < 2"
                                placeholder="Set Width"
                              />
                            </div>
                          </div>
                          <div class="col-3 pl-0">
                            <div class="input-material mt-2">
                              <input
                                type="number"
                                v-model="signageItem.height"
                                :disabled="signageItemIndex < 2"
                                placeholder="Set Height"
                              />
                            </div>
                          </div>
                          <div class="col-3 pl-0">
                            <label
                              class="material-file-upload c-pointer"
                              @click.prevent.stop="
                                setModalData(
                                  signageItem.height,
                                  signageItem.width,
                                  signageItemIndex,
                                  3
                                )
                              "
                            >
                              <div
                                class="label"
                                v-bind:class="{
                                  'shift-up':
                                    signageItem.imageUrl &&
                                    signageItem.imageUrl.length > 0
                                }"
                              >
                                <div class="text-truncate">
                                  Signage Image {{ signageItemIndex + 1 }}
                                </div>
                              </div>
                              <div class="uploaded-file-name">
                                <div class="text-truncate pt-2">
                                  {{ signageItem.imageUrl }}
                                </div>
                              </div>
                            </label>
                          </div>

                          <div
                            class="col-2 align-self-start"
                            v-if="signageItem.imageUrl"
                          >
                            <ImagePreviewer
                              :img="_GetImagePath(signageItem.imageUrl)"
                              :clickFunc="
                                () => {
                                  openImageModal(
                                    'Signage ' + `(${signageItem.imageUrl})`,
                                    signageItem.imageUrl
                                  );
                                }
                              "
                            />
                            <img
                              v-if="signageItem.imageUrl"
                              src="@/assets/img/icons/download.svg"
                              height="25"
                              width="25"
                              class="rounded cursor-pointer"
                              @click="
                                downloadImageSignage(
                                  signageItem,
                                  signageItemIndex
                                )
                              "
                            />
                            <img
                              v-if="signageItem.imageUrl"
                              src="@/assets/img/icons/trash.svg"
                              height="25"
                              width="25"
                              class="rounded cursor-pointer"
                              @click="deleteImageSignage(signageItemIndex)"
                            />
                            <!-- <img
                          src="@/assets/img/icons/question.svg"
                          height="20"
                          width="20"
                          class="ml-2"
                          v-b-tooltip.hover
                          :title="
                            `Upload Artwork for the ${MovieContent.langauge} language`
                          "
                        /> -->
                          </div>
                          <div class="col-1" v-if="signageItemIndex > 1">
                            <img
                              class="rounded cursor-pointer"
                              @click.prevent.stop="
                                removeSignage(signageItemIndex)
                              "
                              src="@/assets/img/icons/minus.svg"
                              height="35"
                              width="35"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    class="
                      col-1
                      d-flex
                      justify-content-center
                      align-items-center
                      border-left
                    "
                  >
                    <button
                      @click.prevent.stop="addSignageData()"
                      class="btn-transparent"
                    >
                      <img
                        src="@/assets/img/icons/plus.svg"
                        height="35"
                        width="35"
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-collapse>
      </section>

      <div class="col-lg-6 col-xl-4 align-self-center my-4" v-if="false">
        <div class="d-flex align-items-center">
          <label class="mb-0 mr-3">{{ $t("active") }}</label>
          <b-form-checkbox
            v-model="OffersAndPromotion.os_is_active"
            name="check-button"
            switch
          ></b-form-checkbox>
        </div>
      </div>

      <div class="col-12 mt-4 text-center">
        <button
          class="btn-blue"
          :disabled="btenable"
          @click.prevent.stop="OnFinalSubmit"
        >
          {{ $t("update") }}
        </button>
      </div>
    </div>
    <ImageGallery
      v-bind:propImageName="'Offer Image'"
      v-bind:openModal="showModal"
      v-bind:set_height="set_height"
      v-bind:set_width="set_width"
      :showPercentageLoader="true"
      :img_desc="'Offer Image'"
      :resetImgData="false"
      :category="'Offer Image'"
      :cropSizeResizable="cropSizeEnable"
    ></ImageGallery>
  </div>
</template>

<script>
import { generateRandomCode } from "@/helper/collection";
import ImagePreviewer from "@/components/Partials/ImagePreviewer.vue";
import MasterService from "@/services/MasterService";
import MovieService from "@/services/MovieService";
import moment from "moment";
import PosFnBService from "@/services/Pos_Fnb_Service";
import MarketingService from "@/services/MarketingService";
import ClientService from "@/services/ClientService";
import DatePicker from "vue2-datepicker";
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
import { VueEditor } from "vue2-editor";
import ImageGallery from "../../ImageGallery/imageGalleryModal";
import { mapGetters } from "vuex";
import { BASEURL } from "@/config/index";

export default {
  components: { DatePicker, VueTimepicker, VueEditor, ImageGallery,ImagePreviewer },
  data() {
    return {
      banner_image_height: "690",
      banner_image_width: "2400",
      poster_image_height: "400",
      poster_image_width: "400",
      set_height: null,
      set_width: null,
      showModal: null,

      editCode: false,
      isEdit: true,
      isEditHtml: false,
      notempty: [false, false, false, false, false, false],

      value: "",
      submitted: false,
      btenable: false,
      TicketTypes: [],
      // SAIF
      clientList: [],
      cinemasList: [],
      screenList: [],
      seatClassList: [],
      movieList: [],
      fnbItems: [],
      customerOffersCategories: [],
      institutionList: [],
      activeBankList: [],
      activeBankCardList: [],
      verificationList: [],
      signageContainer: [
        
      ],

      OffersAndPromotion: {
        os_id: null,
        offer_type_id: null,
        offer_title: "",
        offer_code: null, // "PO-" + generateRandomCode(8),
        offer_start_date_time: null, // Start_Date,
        offer_end_date_time: null, // End_date,
        offerValidFor: "fAndb",
        offer_banner_image: "",
        offer_poster_image: "",
        client_id: null,
        share_value: null,
        share_is_percentage: "Y",
        is_employee_offer: "N",
        selectedClient: [],
        os_is_active: true,
        startTime2: "",
        endTime2: "",
      },
      RedemptionOutlet: {
        offer_redeem_at_online: "Y",
        offer_redeem_at_boxoffice: "Y",
        offer_redeem_at_concession: "Y",
        offer_applicable_on: "gross_amount",
      },
      //Collapse
      sectionCollapse: {
        offer: true,
        offerconfig: true,
        offersplitconfig: true,
        otherOfferSettings: true,
        offertype: true,
        outlet: true,
      },

      // Cinemas Screen SeatClass
      selectedCinemaScreenSeatClassList: [
        {
          cine_id: null,
          screen_id: null,
          sst_id: null,
          tt_id: null,
        },
      ],
      CinemasScreenSeatClassdataList: [
        {
          cinemasList: [],
          screenList: [],
          seatClassList: [],
        },
      ],
      // Cinemas Screen SeatClass

      OfferConfiguraion: {
        offer_applicable_on_all_cinemas: "N",
        selectedMovielist: [],
        pvms_start_show_time: "",
        pvms_end_show_time: "",
        avail_on_advanced_booking: "N",

        // selectedMovie: null,
        // md_id: null,
        SelectedCinemas: null,
        cine_id: null,
        SelectedScreen: null,
        screen_id: null,
        SelectedClass: null,
        sst_id: null,
        tt_id: null,
        // offer_applicable_on_all_movies: "Y",
        // offer_applicable_on_all_day: "Y",
        // startDateTime: null,
        // endDateTime: null
      },
      weekDays: {
        selectAll: false,
        sunday: false,
        monday: false,
        tuesday: false,
        wednesday: false,
        thursday: false,
        friday: false,
        saturday: false,
      },

      // selectedOfferType: "buyAndGetFreeTickets",
      selectedOfferType: "",
      buyAndGetFreeTickets: {
        oc_buy_no_of_ticket: null,
        oc_get_free_ticket: null,
        oc_min_ticket_price: null,
        oc_max_no_of_ticket_per_transaction: null,
        oc_combine_with_other_offers: "N",

        selectedCombineoffer: null,
      },

      buyAndgetOffOnAnother: {
        oc_buy_no_of_ticket: null,
        oc_discount_value: "",
        oc_discount_value_is_percentage: "Y",
        oc_offer_on_higher_amount: "N",
        oc_max_count_of_ticket: null,
        oc_max_discount_amount: null,
      },

      buyTicketFnbFixedPrice: {
        oc_buy_no_of_ticket: null,
        oc_ticket_at_price: null,
        oc_max_count_of_ticket: null,
        oc_min_ticket_price: null,
        oc_combine_with_fnb: "N",
        Fnb_criteria: [
          {
            oc_buy_no_of_item: null,
            oc_buy_item_id: null,
            oc_buy_item_code: null,
            selectedFnbItem: "",
            oc_fnb_at_price: null,
          },
        ],
      },
      buyAndGetCombo: {
        offerApplicableAt: "boxOffice",
        boxOffice: {
          oc_buy_no_of_ticket: null,
          oc_get_item_id: null,
          oc_is_combo_free: "N",
          oc_discount_value: null,
          oc_discount_value_is_percentage: "N",
          amount: null,
        },
        F_And_B: {
          oc_buy_item_count: null,
          oc_get_item_count: null,
          oc_buy_item_id: null,
          oc_get_item_id: null,
          // SelectedOnFnBItem: null,
          // SelectedFreeFnBItem: null,
          oc_is_combo_free: "N",
          oc_discount_value_is_percentage: "N",
          oc_discount_value: null,
        },
      },
      customCategoryOffers: {
        booking_user_category_id: null, // "student",
        institution_id: null,
        validate_doc_id: null,
        cco_min_ticket_amount: null,
        cco_max_discount_amount: null,
        cco_offer_value: null,
        cco_offer_value_is_percentage: "N",
        cco_instruction: null,
      },
      bankOffer: {
        bank_id: null,
        card_id: null,
        offerForDuration: "weekly",
        redemptionCount: null,
        maxRedemptionPerUser: null,
        bo_offer_value: null,
        bo_offer_value_is_percentage: null,
        bo_instruction: null,
      },
      promoCode: {
        pcs_send_email: "Y",
        pcs_send_sms: "N",
        booking_user_category_id: null,
        institution_id: null,
        multiplePromocode: "N",
        promoCodeList: [
          {
            promo_code: null,
            pcs_no_of_transaction: null,
            pcs_min_ticket_amount: null,
            pcs_max_discount_amount: null,
            pcs_offer_value: null,
            pcs_offer_value_is_percentage: "N",
          },
        ],
        pcs_instruction: null,
      },

      discountLists: [
        {
          oc_buy_no_of_ticket: "",
          oc_discount_value: "",
          oc_discount_value_is_percentage: "N",
          oc_max_discount_amount: null,

          canCombineOtherOffers: "N",
          selectedCombinedOffer: null,
        },
      ],
      // SAIF END

      currentlyActiveOffers: [
        { value: null, text: "Please select an offer" },
        { value: "a", text: "Offer 1" },
        { value: "b", text: "Offer 2" },
        { value: "c", text: "Offer 3" },
        { value: "d", text: "Offer 4 (Expired)", disabled: true },
      ],
      TrueFalseCount: 0,
      osId: null,
      offerContent: [],
      ContentLanguages: [],
      activeClass: 0,
      notempty: [false, false, false, false, false, false],
      uploadIndex: null,
      bannerUpload: false,
      imgUrl: null,
      filePath: null,
      filename: null,
      cropSizeEnable:true
    };
  },
  watch: {
    finalImagePath(newVal) {
      if (this.uploadImageType == 1) {
        this.offerContent[this.uploadIndex].offer_banner_image = newVal;
      }    if (this.uploadImageType == 3) {
         this.signageContainer[this.uploadIndex].imageUrl = newVal;
        }else {
        this.offerContent[this.uploadIndex].offer_poster_image = newVal;
      }
    },
  },
  computed: {
    ...mapGetters(["finalImagePath"]),
    booking_user_category() {
      if (
        this.promoCode.booking_user_category_id &&
        this.promoCode.booking_user_category_id.length > 0
      ) {
        return (
          this.promoCode.booking_user_category_id.filter((singleCategory) => {
            return String(singleCategory.buc_id) === "2";
          }).length > 0
        );
      } else {
        return false;
      }
    },
  },
  beforeMount() {
    let cinemaid =
      this.secureStore.get("USINFO") &&
      this.secureStore.get("USINFO")["cinema_id"]
        ? this.secureStore.get("USINFO").cinema_id
        : null;
    let roleid = this.secureStore.get("USINFO").role_id;

    if (roleid == 3) {
      this.$router.go(-1);
    } else {
      const { os_id } = this.$route.query;
      if (os_id) {
        this.osId = os_id;
        // this.getPromotionsAndOffersDetails(this.osId);
      } else {
        this.$router.go(-1);
      }

      this.getFnBItems();
      this.getCustomerOffersCategories();
      this.getInstituesList();
      this.getBankList();
      // this.getBankCards();
      this.getClientList();
      this.getTicketTypeList();
    }
  },
  mounted() {},
  methods: {
     checkOfferTypeAvailable(offerType) {
      if(this.OffersAndPromotion.is_employee_offer == 'Y') {
        if(offerType == 'fixedDiscount') {
          return true
        } else {
           return false
        }
      } else {
        return true
      }
    },
     onSelectEmployeeDiscount(event) {
      console.log('onSelectEmployeeDiscount event', event);
      this.selectedOfferType = "fixedDiscount";

      this.RedemptionOutlet = {
        offer_redeem_at_online: "N",
        offer_redeem_at_boxoffice: "Y",
        offer_redeem_at_concession: "Y",
        offer_applicable_on: "gross_amount",
      },

      this.buyAndGetFreeTickets = {
        oc_buy_no_of_ticket: null,
        oc_get_free_ticket: null,
        oc_min_ticket_price: null,
        oc_max_no_of_ticket_per_transaction: null,
        oc_combine_with_other_offers: "N",

        selectedCombineoffer: null,
      };

      this.buyTicketFnbFixedPrice = {
        oc_buy_no_of_ticket: null,
        oc_ticket_at_price: null,
        oc_max_count_of_ticket: null,
        oc_min_ticket_price: null,
        oc_combine_with_fnb: "N",
        Fnb_criteria: [
          {
            oc_buy_no_of_item: null,
            oc_buy_item_id: null,
            oc_buy_item_code: null,
            selectedFnbItem: "",
            oc_fnb_at_price: null,
          },
        ],
      };

      this.buyAndgetOffOnAnother = {
        oc_buy_no_of_ticket: null,
        oc_discount_value: "",
        oc_discount_value_is_percentage: "N",
        oc_offer_on_higher_amount: "N",
        oc_max_count_of_ticket: null,
        oc_max_discount_amount: null,
      };
      this.buyAndGetCombo = {
          offerApplicableAt: "boxOffice",
          boxOffice: {
            oc_buy_no_of_ticket: null,
            oc_get_item_id: null,
            oc_is_combo_free: "N",
            oc_discount_value: null,
            oc_discount_value_is_percentage: "N",
            amount: null,
          },
          F_And_B: {
            oc_buy_item_count: null,
            oc_get_item_count: null,
            oc_buy_item_id: null,
            oc_get_item_id: null,
            // SelectedOnFnBItem: null,
            // SelectedFreeFnBItem: null,
            oc_is_combo_free: "N",
            oc_discount_value_is_percentage: "N",
            oc_discount_value: null,
          },
      };
      this.customCategoryOffers = {
        booking_user_category_id: null, // "student",
        institution_id: null,
        validate_doc_id: null,
        cco_min_ticket_amount: null,
        cco_max_discount_amount: null,
        cco_offer_value: null,
        cco_offer_value_is_percentage: "N",
        cco_instruction: null,
      };
      this.bankOffer = {
        bank_id: null,
        card_id: null,
        offerForDuration: "weekly",
        redemptionCount: null,
        maxRedemptionPerUser: null,
        bo_offer_value: null,
        bo_offer_value_is_percentage: null,
        bo_instruction: null,
      };
      this.promoCode = {
        pcs_send_email: "Y",
        pcs_send_sms: "N",
        booking_user_category_id: null,
        institution_id: null,
        multiplePromocode: "N",
        promoCodeList: [
          {
            promo_code: null,
            pcs_no_of_transaction: null,
            pcs_min_ticket_amount: null,
            pcs_max_discount_amount: null,
            pcs_offer_value: null,
            pcs_offer_value_is_percentage: "N",
          },
        ],
        pcs_instruction: null,
      };
      this.discountLists = [
        {
          oc_buy_no_of_ticket: "",
          oc_discount_value: "",
          oc_discount_value_is_percentage: "N",
          oc_max_discount_amount: null,

          canCombineOtherOffers: "N",
          selectedCombinedOffer: null,
        },
      ];
    },
    deleteImageSignage(index) {
      this.signageContainer[index].imageUrl = "";
    },
    downloadImageSignage(obj, index) {
      let imgPath = obj.imageUrl;
      let fileName = ``;
      let extension_array = imgPath.split(".");
      let actual_extension = extension_array[extension_array.length - 1];
      fileName = `Offer_Signage_${obj.width}x${obj.height}.${actual_extension}`;
      this._downloadImagePath(imgPath, fileName);
    },
    onChangeCount(event, offerType, type) {
      let value = event.target.value;
      if(offerType == 'buyTicketFnbFixedPrice') {
        if(type == 'buy') {
          this.buyTicketFnbFixedPrice.oc_max_count_of_ticket = value;
        } else if(type == 'max') {
          if(value && this.buyTicketFnbFixedPrice.oc_buy_no_of_ticket && parseInt(this.buyTicketFnbFixedPrice.oc_buy_no_of_ticket) > parseInt(value)) {
            this.buyTicketFnbFixedPrice.oc_max_count_of_ticket = this.buyTicketFnbFixedPrice.oc_buy_no_of_ticket;
            this.$toasted.show('Max Limit Must be Greater or Equal to No. of Buy Tickets')
            this.$forceUpdate();
          }
        }
      } else if(offerType == 'buyAndgetOffOnAnother') {
        if(type == 'buy') {
          this.buyAndgetOffOnAnother.oc_max_count_of_ticket = value;
        } else if(type == 'max') {
          if(value && this.buyAndgetOffOnAnother.oc_buy_no_of_ticket && parseInt(this.buyAndgetOffOnAnother.oc_buy_no_of_ticket) > parseInt(value)) {
            this.buyAndgetOffOnAnother.oc_max_count_of_ticket = this.buyAndgetOffOnAnother.oc_buy_no_of_ticket;
            this.$toasted.show('Max Limit Must be Greater or Equal to No. of Buy Tickets')
            this.$forceUpdate();
          }
        }
      } 
    },
    selectFnbItemFixedOffer(event, index, type) {
      if (type == "Add") {
        this.buyTicketFnbFixedPrice.Fnb_criteria[index].oc_buy_item_id =
          event.item_id;
        this.buyTicketFnbFixedPrice.Fnb_criteria[index].oc_buy_item_code =
          event.item_code;
        this.buyTicketFnbFixedPrice.Fnb_criteria[index].selectedFnbItem = {
          item_id: event.item_id,
          item_name: event.item_name,
          item_code: event.item_code,
        };
      } else if (type == "Remove") {
        this.buyTicketFnbFixedPrice.Fnb_criteria[index].oc_buy_item_id = null;
        this.buyTicketFnbFixedPrice.Fnb_criteria[index].oc_buy_item_code = "";
        this.buyTicketFnbFixedPrice.Fnb_criteria[index].selectedFnbItem = "";
      }
    },
    addFnbCriteria() {
      let fnbObj = {
        oc_buy_no_of_item: null,
        oc_buy_item_id: null,
        oc_buy_item_code: null,
        selectedFnbItem: "",
        oc_fnb_at_price: null,
      };
      this.buyTicketFnbFixedPrice.Fnb_criteria.push(fnbObj);
    },
    removeFnbCriteria(index) {
      this.buyTicketFnbFixedPrice.Fnb_criteria.splice(index, 1);
    },
    onChangeDiscountValue(event, index) {
      let value = event.target.value || 0;
      this.discountLists[index].oc_max_discount_amount = value;
    },
    setModalData(height, width, contentIndex = null, type = 1) {
      this.uploadImageType = type;
      this.bannerUpload = false;
      this.$forceUpdate();
      this.set_height = height;
      this.set_width = width;
      this.uploadIndex = contentIndex;
      this.showModal = !this.showModal;
       if (type==3) {
        this.cropSizeEnable = false;
      } else {
        this.cropSizeEnable = true;
      }
    },
    onChangeTranslationInput(event, content, contentIndex, item) {
      this.CheckEmptyContent(content, contentIndex);
    },
    onChangeTabHandler: function (event, index) {
      this.activeClass = index;
    },
    onChangeText(event, type) {
      this.offerContent.map((x) => {
        if (x.langauge.toLowerCase() == "english") {
          if (type == "name") {
            x.offer_title = event.target.value;
          } else if (type == "desc") {
            x.offer_description = event.target.value;
          }
        }
      });
    },
    CheckEmptyContent: function (Content, index) {
      if (Content.langauge.toLowerCase() !== "english") {
        if (Content.offer_title) {
          this.notempty[index] = true;
        } else {
          this.notempty[index] = false;
        }
      }
    },
    getContentLangauge: function (Content = []) {
      MovieService.GetMovieContentLanguages()
        .then((response) => {
          const { data } = response;
          if (data && data.status) {
            if (data.ContentLanguages.length > 0) {
              this.ContentLanguages = data.ContentLanguages;
            }
            console.log("this.ContentLanguages", this.ContentLanguages);
          } else {
            console.log("data.message :", data.message);
          }
          return;
        })
        .then(() => {
          this.makeLangContainers(Content);
        })
        .catch((error) => {
          console.log("Catch Error On getMovieContentLangauge :", error);
        });
    },
    makeLangContainers: function (Content) {
      this.ContentLanguages.map((x, i) => {
        let Array1 = Content.filter((y) => {
          return y.content_lang_id == x.langaugeId;
        });
        if (Array1.length > 0) {
          x["offer_content_id"] = Array1[0].offer_content_id;
          x["os_id"] = Array1[0].os_id;
          x["offer_title"] = Array1[0].offer_title;
          x["offer_description"] = Array1[0].offer_description;
          x["offer_banner_image"] = Array1[0].offer_banner_image;
          x["offer_poster_image"] = Array1[0].offer_poster_image;
          if (Array1[0].offer_title) {
            this.notempty[i] = true;
          }
        } else {
          x["os_id"] = this.osId;
          x["offer_title"] = "";
          x["offer_description"] = "";
          x["offer_banner_image"] = "";
          x["offer_poster_image"] = "";
        }
      });
      this.offerContent = this.ContentLanguages;
      console.log("hjhf", this.offerContent);
    },
    onChangeOfferType(event) {
      console.log("event", event);
      if (event == "buyAndGetFreeTickets") {
        this.RedemptionOutlet.offer_redeem_at_concession = "N";
      } else if (event == "fixedPriceTicketFnb") {
        this.RedemptionOutlet.offer_redeem_at_concession = "N";
      } else if (event == "buyAndgetOffOnAnother") {
        this.RedemptionOutlet.offer_redeem_at_concession = "N";
      }
    },
    onSelectBank: function (data) {
      // console.log("data :>> ", data);
      this.bankOffer.bank_id = data.bank_id;
      this.getBankCards();
    },
    getPromotionsAndOffersDetails: function (os_id) {
      let loader = this.$loading.show();

      MarketingService.GetSinglePermotiosAndOffers({
        offertypeid: os_id,
        isEdit: true,
      })
        .then((response) => {
          const { data } = response;
          if (data.status) {
            if (data.Records.length > 0) {
              let Records = data.Records[0];
              this.setOffersAndPromotion(Records);
              this.setOfferRedemptionOutlet(Records);
              this.setOfferType(Records, data["PromotionOfferTypesRecords"]);
              this.setOfferDaysValue(
                Records["offer_applicable_on_all_day"],
                data.PromotionOfferDaysRecords
              );
              this.getActiveMovies(
                Records["offer_applicable_on_all_movies"],
                data["PromotionOfferMoviesRecords"]
              );
              this.getCinemasList(
                Records["offer_applicable_on_all_cinemas"],
                data["PromotionOfferCinemasRecords"]
              );
              this.OfferConfiguraion.avail_on_advanced_booking =
                Records["offer_enable_for_pre_booking"];
              // this.set
            }
            if (data.OfferContent && data.OfferContent.length > 0) {
              this.getContentLangauge(data.OfferContent);
            } else {
              this.getContentLangauge();
            }


            if(data.SignageContainer){
              this.signageContainer=data.SignageContainer
            }
          } else {
            this.$toasted.show(data.message || this.AdminError);
          }
        })
        .catch(this._CatchError)
        .finally(() => {
          setTimeout(() => loader.hide(), 1500);
        });
    },
    setOfferType: function (Records, DataRecords) {
      console.log("Records.offer_type_id  :>> ", Records.offer_type_id);
      if (Records["offer_type_id"] && Records.offer_type_id === 1) {
        this.selectedOfferType = "buyAndGetFreeTickets";
        if (DataRecords && DataRecords.length > 0) {
          this.buyAndGetFreeTickets = {
            oc_buy_no_of_ticket: DataRecords[0]["oc_buy_no_of_ticket"] || null,
            oc_get_free_ticket: DataRecords[0]["oc_get_free_ticket"] || null,
            oc_min_ticket_price: DataRecords[0]["oc_min_ticket_price"] || null,
            oc_max_no_of_ticket_per_transaction:
              DataRecords[0]["oc_max_no_of_ticket_per_transaction"] || null,
            oc_combine_with_other_offers: "N",
            selectedCombineoffer: null,
          };
        }
      } else if (Records["offer_type_id"] && Records.offer_type_id === 2) {
        this.selectedOfferType = "discount";

        if (DataRecords && DataRecords.length > 0) {
          this.discountLists = [];
          DataRecords.map((x) => {
            this.discountLists.push({
              oc_buy_no_of_ticket: x["oc_buy_no_of_ticket"] || "",
              oc_discount_value: x["oc_discount_value"] || "",
              oc_discount_value_is_percentage:
                x["oc_discount_value_is_percentage"] || "N",
              oc_max_discount_amount: x["oc_max_discount_amount"] || null,

              canCombineOtherOffers: "N",
              selectedCombinedOffer: null,
            });
          });
        }
      } else if (Records["offer_type_id"] && Records.offer_type_id === 8) {
        this.selectedOfferType = "fixedDiscount";

        if (DataRecords && DataRecords.length > 0) {
          this.discountLists = [];
          DataRecords.map((x) => {
            this.discountLists.push({
              oc_buy_no_of_ticket: x["oc_buy_no_of_ticket"] || "",
              oc_discount_value: x["oc_discount_value"] || "",
              oc_discount_value_is_percentage:
                x["oc_discount_value_is_percentage"] || "N",
              oc_max_discount_amount: x["oc_max_discount_amount"] || null,

              canCombineOtherOffers: "N",
              selectedCombinedOffer: null,
            });
          });
        }
      } else if (Records["offer_type_id"] && Records.offer_type_id === 7) {
        this.selectedOfferType = "loyalitycustomers";

        if (DataRecords && DataRecords.length > 0) {
          this.discountLists = [];
          DataRecords.map((x) => {
            this.discountLists.push({
              oc_buy_no_of_ticket: x["oc_buy_no_of_ticket"] || "",
              oc_discount_value: x["oc_discount_value"] || "",
              oc_discount_value_is_percentage:
                x["oc_discount_value_is_percentage"] || "N",
              oc_max_discount_amount: x["oc_max_discount_amount"] || null,

              canCombineOtherOffers: "N",
              selectedCombinedOffer: null,
            });
          });
        }
      } else if (Records["offer_type_id"] && Records.offer_type_id === 3) {
        this.selectedOfferType = "buyAndGetCombo";
        if (
          DataRecords &&
          DataRecords.length > 0 &&
          DataRecords[0]["oc_buy_no_of_ticket"] &&
          !DataRecords[0]["oc_buy_item_id"]
        ) {
          this.buyAndGetCombo.offerApplicableAt = "boxOffice";
          let oc_getFnbItem = this.fnbItems.filter(
            (x) => x.item_id == DataRecords[0]["oc_get_item_id"]
          );
          let getfnbItemObj = null;
          if (oc_getFnbItem && oc_getFnbItem.length > 0) {
            getfnbItemObj = oc_getFnbItem[0];
          }
          this.buyAndGetCombo.boxOffice = {
            oc_buy_no_of_ticket: DataRecords[0]["oc_buy_no_of_ticket"] || null,
            oc_get_item_id: getfnbItemObj || null,
            oc_is_combo_free: DataRecords[0]["oc_is_combo_free"] || "N",
            oc_discount_value: DataRecords[0]["oc_discount_value"] || null,
            oc_discount_value_is_percentage:
              DataRecords[0]["oc_discount_value_is_percentage"] || "N",
            amount: null,
          };
        } else if (
          DataRecords &&
          DataRecords.length > 0 &&
          !DataRecords[0]["oc_buy_no_of_ticket"] &&
          DataRecords[0]["oc_buy_item_id"]
        ) {
          this.buyAndGetCombo.offerApplicableAt = "fAndb";
          let oc_buyFnbItem = this.fnbItems.filter(
            (x) => x.item_id == DataRecords[0]["oc_buy_item_id"]
          );
          let oc_getFnbItem = this.fnbItems.filter(
            (x) => x.item_id == DataRecords[0]["oc_get_item_id"]
          );
          let getfnbItemObj = null;
          let buyfnbItemObj = null;
          if (oc_getFnbItem && oc_getFnbItem.length > 0) {
            getfnbItemObj = oc_getFnbItem[0];
          }
          if (oc_buyFnbItem && oc_buyFnbItem.length > 0) {
            buyfnbItemObj = oc_buyFnbItem[0];
          }
          this.buyAndGetCombo.F_And_B = {
            oc_buy_item_count: DataRecords[0]["oc_buy_item_count"],
            oc_get_item_count: DataRecords[0]["oc_get_item_count"],
            oc_buy_item_id: buyfnbItemObj,
            oc_get_item_id: getfnbItemObj,
            // SelectedOnFnBItem: null,
            // SelectedFreeFnBItem: null,
            oc_discount_value_is_percentage:
              DataRecords[0]["oc_discount_value_is_percentage"] || "N",
            oc_is_combo_free: DataRecords[0]["oc_is_combo_free"] || "N",
            oc_discount_value: DataRecords[0]["oc_discount_value"],
          };
        }
      } else if (Records["offer_type_id"] && Records.offer_type_id === 4) {
        this.selectedOfferType = "customCategoryOffers";
        console.log("DataRecords :>> ", DataRecords);
        if (DataRecords && DataRecords.length > 0) {
          this.customCategoryOffers = {
            booking_user_category_id:
              DataRecords[0]["booking_user_category_id"], // "student",
            institution_id: DataRecords[0]["institution_id"],
            validate_doc_id: null,
            cco_min_ticket_amount: DataRecords[0]["cco_min_ticket_amount"],
            cco_max_discount_amount: DataRecords[0]["cco_max_discount_amount"],
            cco_offer_value: DataRecords[0]["cco_offer_value"],
            cco_offer_value_is_percentage:
              DataRecords[0]["cco_offer_value_is_percentage"] || "N",
            cco_instruction: DataRecords[0]["cco_instruction"],
          };
          this.getVerificationList(DataRecords[0]["validate_doc_id"]);
        } else {
          this.getVerificationList(null);
        }
      } else if (Records["offer_type_id"] && Records.offer_type_id === 5) {
        this.selectedOfferType = "bankOffer";
        if (DataRecords && DataRecords.length > 0) {
          this.bankOffer = {
            bank_id: DataRecords[0]["bank_id"],
            card_id: DataRecords[0]["card_id"],
            offerForDuration: "weekly",
            redemptionCount: null,
            maxRedemptionPerUser: DataRecords[0]["bo_max_redemption_per_user"],
            bo_offer_value: DataRecords[0]["bo_offer_value"],
            bo_offer_value_is_percentage:
              DataRecords[0]["bo_offer_value_is_percentage"],
            bo_instruction: DataRecords[0]["bo_instruction"],
          };

          this.getBankCards();
          if (
            DataRecords[0]["bo_weekly_redemption"] &&
            String(DataRecords[0]["bo_weekly_redemption"]).length > 0
          ) {
            this.bankOffer.offerForDuration = "weekly";
            this.bankOffer.redemptionCount =
              DataRecords[0]["bo_weekly_redemption"];
          } else if (
            DataRecords[0]["bo_monthly_redemption"] &&
            String(DataRecords[0]["bo_monthly_redemption"]).length > 0
          ) {
            this.bankOffer.offerForDuration = "monthly";
            this.bankOffer.redemptionCount =
              DataRecords[0]["bo_monthly_redemption"];
          } else if (
            DataRecords[0]["bo_yearly_redemption"] &&
            String(DataRecords[0]["bo_yearly_redemption"]).length > 0
          ) {
            this.bankOffer.offerForDuration = "yearly";
            this.bankOffer.redemptionCount =
              DataRecords[0]["bo_yearly_redemption"];
          }
        }
      } else if (Records["offer_type_id"] && Records.offer_type_id === 6) {
        this.selectedOfferType = "promoCode";
        if (DataRecords && DataRecords.length > 0) {
          if (DataRecords.length === 1) {
            this.promoCode = {
              pcs_send_email: DataRecords[0]["pcs_send_email"] || "N",
              pcs_send_sms: DataRecords[0]["pcs_send_sms"] || "N",
              booking_user_category_id: [], //////
              institution_id: DataRecords[0]["institution_id"] || null,
              multiplePromocode: "N",
              promoCodeList: [
                {
                  promo_code: DataRecords[0]["promo_code"] || null,
                  pcs_no_of_transaction:
                    DataRecords[0]["pcs_no_of_transactions"] || null,
                  pcs_min_ticket_amount:
                    DataRecords[0]["pcs_min_ticket_amount"] || null,
                  pcs_max_discount_amount:
                    DataRecords[0]["pcs_max_discount_amount"] || null,
                  pcs_offer_value: DataRecords[0]["pcs_offer_value"] || null,
                  pcs_offer_value_is_percentage:
                    DataRecords[0]["pcs_offer_value_is_percentage"] || "N",
                },
              ],
              pcs_instruction: DataRecords[0]["pcs_instruction"] || null,
            };
          } else if (DataRecords.length > 1) {
            this.promoCode.multiplePromocode = "Y";
            this.promoCode = {
              pcs_send_email: DataRecords[0]["pcs_send_email"] || "N",
              pcs_send_sms: DataRecords[0]["pcs_send_sms"] || "N",
              booking_user_category_id: [], //////
              institution_id: DataRecords[0]["institution_id"] || null,
              multiplePromocode: "N",
              promoCodeList: [],
              pcs_instruction: DataRecords[0]["pcs_instruction"] || null,
            };

            DataRecords.map((x) => {
              this.promoCode.promoCodeList.push({
                promo_code: x["promo_code"] || null,
                pcs_no_of_transaction: x["pcs_no_of_transactions"] || null,
                pcs_min_ticket_amount: x["pcs_min_ticket_amount"] || null,
                pcs_max_discount_amount: x["pcs_max_discount_amount"] || null,
                pcs_offer_value: x["pcs_offer_value"] || null,
                pcs_offer_value_is_percentage:
                  x["pcs_offer_value_is_percentage"] || "N",
              });
            });
          }
          this.getCustomerOffersCategories(
            DataRecords[0]["booking_user_category_id"]
          );
        }
      } else if (Records["offer_type_id"] && Records.offer_type_id === 9) {
        this.selectedOfferType = "fixedPriceTicketFnb";

        if (DataRecords && DataRecords.length > 0) {
          let oc_getFnbItem = this.fnbItems.filter(
            (x) => x.item_id == DataRecords[0]["oc_get_item_id"]
          );
          this.buyTicketFnbFixedPrice = {
            oc_buy_no_of_ticket: DataRecords[0]["oc_buy_no_of_ticket"],
            oc_ticket_at_price: DataRecords[0]["oc_discount_value"],
            oc_max_count_of_ticket:
              DataRecords[0]["oc_max_no_of_ticket_per_transaction"],
            oc_min_ticket_price: null,
            oc_combine_with_fnb: DataRecords[0]["oc_is_combo_with_fnb"],
            Fnb_criteria: [
              {
                oc_buy_no_of_item: null,
                oc_buy_item_id: null,
                oc_buy_item_code: null,
                selectedFnbItem: "",
                oc_fnb_at_price: null,
              },
            ],
          };

          if (
            Array.isArray(DataRecords[0]["fnb_group_data"]) &&
            DataRecords[0]["fnb_group_data"].length > 0
          ) {
            DataRecords[0]["fnb_group_data"].forEach((y) => {
              let selectedItem = this.fnbItems.find(
                (x) => x.item_id == y["oc_buy_item_id"]
              );
              if (selectedItem) {
                let obj = {
                  item_id: selectedItem["item_id"],
                  item_name: selectedItem["item_name"],
                  item_code: selectedItem["item_code"],
                };
                y["selectedFnbItem"] = obj;
              }
            });
            this.buyTicketFnbFixedPrice["Fnb_criteria"] =
              DataRecords[0]["fnb_group_data"];
          } else {
            this.buyTicketFnbFixedPrice["Fnb_criteria"] = [];
          }
        }
      } else if (Records["offer_type_id"] && Records.offer_type_id === 10) {
        this.selectedOfferType = "buyAndgetOffOnAnother";

        if (DataRecords && DataRecords.length > 0) {
          this.buyAndgetOffOnAnother = {
            oc_buy_no_of_ticket: DataRecords[0]["oc_buy_no_of_ticket"],
            oc_discount_value: DataRecords[0]["oc_discount_value"],
            oc_discount_value_is_percentage:
              DataRecords[0]["oc_discount_value_is_percentage"],
            oc_offer_on_higher_amount:
              DataRecords[0]["oc_offer_on_higher_amount"],
            oc_max_count_of_ticket:
              DataRecords[0]["oc_max_no_of_ticket_per_transaction"],
            oc_max_discount_amount: DataRecords[0]["oc_max_discount_amount"],
          };
        }
      }
    },
    setOfferTypesRecords: function () {},
    setOfferDaysValue: function (alldays, voucherDays) {
      let days = {
        sunday: "pvds_sunday",
        monday: "pvds_monday",
        tuesday: "pvds_tuesday",
        wednesday: "pvds_wednesday",
        thursday: "pvds_thursday",
        friday: "pvds_friday",
        saturday: "pvds_saturday",
      };
      Object.keys(days).map((x) => {
        this.weekDays[x] =
          alldays && alldays === "Y"
            ? true
            : voucherDays &&
              voucherDays.length > 0 &&
              voucherDays[0][days[x]] === "Y"
            ? true
            : false;
      });

      let array = Object.keys(this.weekDays).filter(
        (x) => x !== "selectAll" && !this.weekDays[x]
      );
      if (alldays && alldays === "Y") {
        this.weekDays["selectAll"] = true;
      } else if (array.length === 0) {
        this.weekDays["selectAll"] = true;
      }
    },
    setOffersAndPromotion: function (Records) {
      this.OffersAndPromotion = {
        os_id: Records.os_id,
        offer_type_id: Records.offer_type_id,
        offer_title: Records.offer_title,
        offer_code: Records.offer_code, // "PO-" + generateRandomCode(8),
        offer_start_date_time: Records.offer_start_date_time, // Start_Date,
        offer_end_date_time: Records.offer_end_date_time, // End_date,
        startTime2: moment(Records.offer_start_time, "HH:mm:ss").format(
          "HH:mm"
        ),
        endTime2: moment(Records.offer_end_time, "HH:mm:ss").format("HH:mm"),
        offerValidFor: "fAndb",
        client_id: Records.client_id,
        share_value: Records.client_share_value,
        share_is_percentage: Records.client_share_is_percentage,
        is_employee_offer: Records.is_employee_offer || 'N',
        share_is_percentage: "Y",
        os_is_active: Records.os_is_active == "Y" ? true : false,
      };
      if (Records.client_id) {
        this.setClientName(Records.client_id);
      }
    },
    setClientName: function (client_id) {
      ClientService.GetSingleClientDetails({ client_id })
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            let obj = data.Records[0];
            this.OffersAndPromotion.selectedClient = obj;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    onSelectClient: function (client) {
      this.OffersAndPromotion.client_id = client.client_id;
      this.OffersAndPromotion.selectedClient = client;
      this.$forceUpdate();
    },
    setOfferRedemptionOutlet: function (Records) {
      this.RedemptionOutlet = {
        offer_redeem_at_online: Records["offer_redeem_at_online"] || "N",
        offer_redeem_at_boxoffice: Records["offer_redeem_at_boxoffice"] || "N",
        offer_redeem_at_concession:
          Records["offer_redeem_at_concession"] || "N",
        offer_applicable_on: "gross_amount",
      };
      if (
        Records["offer_applicable_on_net_amount"] &&
        Records.offer_applicable_on_net_amount === "Y"
      ) {
        this.RedemptionOutlet["offer_applicable_on"] = "net_amount";
      } else if (
        Records["offer_applicable_on_gross_amount"] &&
        Records.offer_applicable_on_gross_amount === "Y"
      ) {
        this.RedemptionOutlet["offer_applicable_on"] = "gross_amount";
      }
    },
    selectTicketType(tt, index) {
      console.log("index :>> ", index);
      this.selectedCinemaScreenSeatClassList[index].tt_id = tt.tt_id;
    },
    onChangeWeekdays: function (event, keyname) {
      this.TrueFalseCount = 0;

      if (keyname !== "selectAll") {
        this.weekDays["selectAll"] = false;
        this.weekDays[keyname] = event;
      }

      let len = Object.keys(this.weekDays).length;
      if (keyname === "selectAll" && event) {
        Object.keys(this.weekDays).map((x) => {
          x !== "selectAll" ? (this.weekDays[x] = true) : "";
        });
      } else if (keyname === "selectAll" && !event) {
        Object.keys(this.weekDays).map((x) => {
          x !== "selectAll" ? (this.weekDays[x] = false) : "";
        });
      } else if (keyname !== "selectAll" && this.weekDays.selectAll) {
        this.weekDays["selectAll"] = false;
      }

      Object.keys(this.weekDays).map((x) => {
        if (x != "selectAll") {
          if (this.weekDays[x] === false) {
            this.TrueFalseCount++;
          }
        }
      });

      // if (
      //   Object.keys(this.weekDays).filter(x => this.weekDays[x]).length ===
      //   len - 1
      // ) {
      //   this.weekDays["selectAll"] = true;
      // }
    },
    getCinemasList: function (isAllCinemas, DataCinemasList) {
      this.cinemasList = [];
      let payload = {
        tableName: "ms_cinemas",
        cine_is_active: "Y",
      };
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data.status) {
            // data.Records.length > 0 ? (this.cinemasList = data.Records) : "";
            if (data.Records.length > 0) {
              this.cinemasList = data.Records;
              // this.CinemasScreenSeatClassdataList[0].cinemasList = data.Records;
              if (
                isAllCinemas &&
                isAllCinemas === "N" &&
                DataCinemasList &&
                DataCinemasList.length > 0
              ) {
                console.log("isAllCinemas :", isAllCinemas);
                this.OfferConfiguraion.offer_applicable_on_all_cinemas =
                  isAllCinemas === "N" ? "Y" : "N";
                this.selectedCinemaScreenSeatClassList = [];
                this.CinemasScreenSeatClassdataList = [];
                DataCinemasList.map(async (x, index) => {
                  let findIndex = data.Records.findIndex(
                    (z) => z.cine_id === x.cine_id
                  );
                  if (findIndex !== -1) {
                    // selectedCinemaScreenSeatClassList

                    await this.CinemasScreenSeatClassdataList.push({
                      cinemasList: this.cinemasList,
                      screenList: [],
                      seatClassList: [],
                    });
                    const selectedTicketType = this.TicketTypes.find(
                      (t) => t.tt_id === x["tt_id"]
                    );
                    console.log("selectedTicketType", selectedTicketType);
                    console.log(' x["tt_id"]', x["tt_id"]);
                    await this.selectedCinemaScreenSeatClassList.push({
                      cine_id: x["cine_id"] || null,
                      screen_id: x["screen_id"] || null,
                      sst_id: x["seat_type_id"] || null,
                      tt_id: selectedTicketType || null,
                    });
                    await this.getScreenList(x.cine_id, index, "Not");
                    await this.getSeatClassList(x["screen_id"], index, "Not");
                  }
                });
              }
            }
          } else {
            this.$toasted.show(data.message || this.AdminError);
          }
        })
        .catch(this._CatchError);
    },
    getScreenList: function (cinema_id, Indexx, val) {
      // this.screenList = [];
      // this.seatClassList = [];
      // this.OfferConfiguraion.screen_id = null;
      // this.OfferConfiguraion.sst_id = null;

      this.CinemasScreenSeatClassdataList[Indexx].screenList = [];

      this.CinemasScreenSeatClassdataList[Indexx].seatClassList = [];
      if (!val || val !== "Not") {
        this.selectedCinemaScreenSeatClassList[Indexx].screen_id = null;
        this.selectedCinemaScreenSeatClassList[Indexx].sst_id = null;
      }

      if (cinema_id) {
        let payload = {
          tableName: "screens",
          screen_is_active: "Y",
          cinema_id,
        };
        MasterService.GetActiveList(payload)
          .then((response) => {
            const { data } = response;
            if (data.status) {
              if (data.Records.length > 0) {
                // this.screenList = data.Records
                this.CinemasScreenSeatClassdataList[Indexx].screenList =
                  data.Records;
              }
            } else {
              this.$toasted.show(data.message || this.AdminError);
            }
          })
          .catch(this._CatchError);
      }
    },
    getSeatClassList: function (screen_id, Indexx, val) {
      // this.seatClassList = [];
      // this.OfferConfiguraion.sst_id = null;

      this.CinemasScreenSeatClassdataList[Indexx].seatClassList = [];
      if (!val || val !== "Not") {
        this.selectedCinemaScreenSeatClassList[Indexx].sst_id = null;
        this.selectedCinemaScreenSeatClassList[Indexx].sst_id = null;
      }

      if (screen_id) {
        let payload = {
          tableName: "screen_seat_type",
          screen_id: screen_id,
          sst_is_active: "Y",
        };
        MasterService.GetActiveList(payload)
          .then((response) => {
            const { data } = response;
            if (data.status) {
              if (data.Records.length > 0) {
                // this.seatClassList = data.Records;
                this.CinemasScreenSeatClassdataList[Indexx].seatClassList =
                  data.Records;
              }
            } else {
              this.$toasted.show(data.message || this.AdminError);
            }
          })
          .catch(this._CatchError);
      }
    },
    getClientList() {
      ClientService.GetAllClients({})
        .then((response) => {
          const { data } = response;
          if (data && data.status) {
            this.clientList = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch((error) => {
          this.$toasted.show(error);
        });
    },
    getActiveMovies: function (isAllMovies, DataMoviesList) {
      this.movieList = [];
      let payload = {
        movieversions: "Y",
      };
      MovieService.GetActiveMoviesWithFormat(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status) {
            if (data.Records.length > 0) {
              this.movieList = data.Records;

              if (
                isAllMovies &&
                isAllMovies === "N" &&
                DataMoviesList &&
                DataMoviesList.length > 0
              ) {
                data.Records.map((x, index) => {
                  if (index) {
                    this.OfferConfiguraion.pvms_start_show_time =
                      x.pvms_start_show_time;
                    this.OfferConfiguraion.pvms_end_show_time =
                      x.pvms_end_show_time;
                  }
                  let findIndex = DataMoviesList.findIndex(
                    (z) => x.md_id === z.movie_detail_id
                  );
                  findIndex !== -1
                    ? this.OfferConfiguraion.selectedMovielist.push(x)
                    : "";
                });

                DataMoviesList.map((x) => {
                  console.log("x", x);
                  // this.OfferConfiguraion.pvms_start_show_time = this.TimeToDateConvertor(
                  //   x.pvms_start_show_time
                  // );
                  this.OfferConfiguraion.pvms_start_show_time = moment(
                    x.pvms_start_show_time,
                    "HH:mm:ss"
                  ).format("HH:mm");
                  this.OfferConfiguraion.pvms_end_show_time = moment(
                    x.pvms_end_show_time,
                    "HH:mm:ss"
                  ).format("HH:mm");

                  // this.OfferConfiguraion.pvms_end_show_time = this.TimeToDateConvertor(
                  //   x.pvms_end_show_time
                  // );
                });
              }
            }
          } else {
            // Show Error Message
            this.$toasted.show(data.message || this.AdminError);
          }
        })
        .catch(this._CatchError);
    },
    TimeToDateConvertor: function (time) {
      let Time = time.split(":");
      let hour = parseInt(Time[0], 10);
      let minute = parseInt(Time[1], 10);
      let date = new Date(null, null, null, hour, minute);
      return date;
    },
    getFnBItems: function () {
      MarketingService.GetAllFNBItems()
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records) {
            data.Records.length > 0 ? (this.fnbItems = data.Records) : "";
          } else {
            this.$toasted.show(data.message || "Opps! Something went wrong");
          }
        })
        .catch(this._CatchError)
        .finally(() => {
          this.getPromotionsAndOffersDetails(this.osId);
        });
    },
    getCustomerOffersCategories: function (DataCategory) {
      MarketingService.GetCustomerCategories()
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records) {
            if (data.Records.length > 0) {
              this.customerOffersCategories = data.Records;
              if (DataCategory && String(DataCategory).length > 0) {
                let arrayList = DataCategory.split(", ");
                data.Records.map((x) => {
                  let findIndex = arrayList.findIndex(
                    (z) => z === String(x.buc_id)
                  );
                  if (findIndex !== -1) {
                    this.promoCode.booking_user_category_id.push(x);
                  }
                });
              } else {
                this.customCategoryOffers.booking_user_category_id =
                  data.Records[0].buc_id;
              }
            }
          } else {
            this.$toasted.show(data.message || "Opps! Something went wrong");
          }
        })
        .catch(this._CatchError);
    },
    getInstituesList: function () {
      MarketingService.GetActiveInstitites()
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records) {
            if (data.Records.length > 0) {
              this.institutionList = data.Records;
            }
          } else {
            console.log("getInstituesList data.message", data.message);
            // this.$toasted.show(data.message || "Opps! Something went wrong");
          }
        })
        .catch((err) => {
          console.log("getInstituesList CATCH ERROR", err);
        });
    },
    getBankList: function () {
      MarketingService.GetActiveBanks()
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records) {
            if (data.Records.length > 0) {
              this.activeBankList = data.Records;
            }
          } else {
            console.log("getBankList data.message", data.message);
            // this.$toasted.show(data.message || "Opps! Something went wrong");
          }
        })
        .catch((err) => {
          console.log("getBankList CATCH ERROR", err);
        });
    },
    getBankCards: function () {
      this.activeBankCardList = [];
      MarketingService.GetActiveBanksCards(this.bankOffer.bank_id)
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records) {
            if (data.Records.length > 0) {
              this.activeBankCardList = data.Records;
            }
          } else {
            console.log("getBankCards data.message", data.message);
            // this.$toasted.show(data.message || "Opps! Something went wrong");
          }
        })
        .catch((err) => {
          console.log("getBankCards CATCH ERROR", err);
        });
    },
    async getTicketTypeList() {
      try {
        this.TicketTypes = [];
        let body = {
          tableName: "ms_ticket_type",
        };
        const { data } = await MasterService.GetActiveList(body);

        if (data && data.status && data.Records.length > 0) {
          this.TicketTypes = data.Records;
        } else {
          this.$toasted.show(data.message || "Opps! Something went wrong");
        }
      } catch (error) {
        console.error(error);
      }
    },
    getVerificationList: function (DataList) {
      console.log("in here :>> ");
      MarketingService.GetVerificationList()
        .then((response) => {
          const { data } = response;
          if (data && data.status) {
            if (data.Records.length > 0) {
              this.verificationList = data.Records;
              if (DataList && DataList.length > 0) {
                let arraylist = DataList.split(", ");
                this.customCategoryOffers.validate_doc_id = [];
                data.Records.map((x) => {
                  let findIndex = arraylist.findIndex(
                    (z) => String(x.vd_id) === z
                  );
                  if (findIndex !== -1) {
                    this.customCategoryOffers.validate_doc_id.push(x);
                  }
                });
              }
            }
          } else this.$toasted.show(data.message || this.AdminError);
        })
        .catch(this._CatchError);
    },
    showError: function (message) {
      this.$toasted.show(message, {
        duration: null,
        action: {
          text: "x",
          onClick: (e, toastObject) => toastObject.goAway(0),
        },
      });
    },
    convertTime(date, time) {
      const d = moment(date).format("YYYY-MM-DD");
      const newdate = moment(d + " " + time).format("YYYY-MM-DD HH:mm");
      return newdate;
    },
    validateOfferData(showToastMsg = true) {
      let errorCount = 0;
      let errorMsg = ``;
      if (this.selectedOfferType == "fixedPriceTicketFnb") {
        if (
          isNaN(this.buyTicketFnbFixedPrice.oc_buy_no_of_ticket) ||
          !this.buyTicketFnbFixedPrice.oc_buy_no_of_ticket
        ) {
          errorCount++;
          errorMsg = `Please Enter Buy No. Of Ticket`;
        } else if (
          isNaN(this.buyTicketFnbFixedPrice.oc_ticket_at_price) ||
          !this.buyTicketFnbFixedPrice.oc_ticket_at_price
        ) {
          errorCount++;
          errorMsg = `Please Enter Flat Ticket Price`;
        } else {
          if (this.buyTicketFnbFixedPrice.oc_combine_with_fnb == "Y") {
            this.buyTicketFnbFixedPrice.Fnb_criteria.map((x) => {
              if (isNaN(x.oc_buy_no_of_item) || !x.oc_buy_no_of_item) {
                errorCount++;
                errorMsg = `Please Enter Buy No. Of Items`;
              } else if (isNaN(x.oc_fnb_at_price) || !x.oc_fnb_at_price) {
                errorCount++;
                errorMsg = `Please Enter Flat Item Price`;
              } else if (!x.oc_buy_item_code) {
                errorCount++;
                errorMsg = `Please Select Item`;
              }
            });
          }
        }
      }

      if (errorCount > 0) {
        if (showToastMsg) {
          this.$toasted.show(errorMsg);
        }
        return false;
      } else {
        return true;
      }
    },
    OnFinalSubmit: function () {
      this.submitted = true;

      if (
        this.OffersAndPromotion.offer_start_date_time >
        this.OffersAndPromotion.offer_end_date_time
      ) {
        return this.$toasted.show("Please Enter Proper Dates");
      } else {
        if (
          this.OffersAndPromotion.startTime2 &&
          moment(this.OffersAndPromotion.startTime2, "HH:mm").isValid()
        ) {
          this.OffersAndPromotion.offer_start_date_time = this.convertTime(
            this.OffersAndPromotion.offer_start_date_time,
            this.OffersAndPromotion.startTime2
          );
        }
        if (
          this.OffersAndPromotion.endTime2 &&
          moment(this.OffersAndPromotion.endTime2, "HH:mm").isValid()
        ) {
          this.OffersAndPromotion.offer_end_date_time = this.convertTime(
            this.OffersAndPromotion.offer_end_date_time,
            this.OffersAndPromotion.endTime2
          );
        }
      }

      const { os_id } = this.$route.query;

      // if (
      //   !this.OffersAndPromotion.offer_title ||
      //   String(this.OffersAndPromotion.offer_title).length === 0
      // ) {
      //   this.showError("Please enter offer title");
      // } else if (
      //   !this.OffersAndPromotion.offer_code ||
      //   String(this.OffersAndPromotion.offer_code).length === 0
      // ) {
      //   this.showError("Please enter offer code");
      // } else {
      if (
        this.selectedOfferType == "buyAndGetFreeTickets" &&
        this.buyAndGetFreeTickets.oc_get_free_ticket >
          this.buyAndGetFreeTickets.oc_max_no_of_ticket_per_transaction
      ) {
        return this.$toasted.show(
          "Maximum Number of free tickets Must be greater and Offer Free ticket"
        );
      }

      if (!this.validateOfferData()) {
        return;
      }
      console.log("this.$errors", this.errors);

      this.$validator.validate().then((valid) => {
        if (this.TrueFalseCount == 7) {
          console.log("TrueFalseCount locking", this.TrueFalseCount);
          return;
        }
        // if (
        //   !this.OffersAndPromotion.selectedClient ||
        //   this.OffersAndPromotion.selectedClient.length == 0
        // ) {
        //   return;
        // }
        if (
          (this.selectedOfferType == "buyAndGetCombo" &&
            this.buyAndGetCombo.offerApplicableAt === "fAndb" &&
            this.buyAndGetCombo.F_And_B.oc_buy_item_id == null) ||
          (this.selectedOfferType == "buyAndGetCombo" &&
            this.buyAndGetCombo.offerApplicableAt === "fAndb" &&
            this.buyAndGetCombo.F_And_B.oc_get_item_id == null) ||
          (this.selectedOfferType == "buyAndGetCombo" &&
            this.buyAndGetCombo.offerApplicableAt === "boxOffice" &&
            this.buyAndGetCombo.boxOffice.oc_get_item_id == null)
        ) {
          console.log("lockinh here 4890");
          return;
        }
        if (
          (this.selectedOfferType == "customCategoryOffers" &&
            String(this.customCategoryOffers.booking_user_category_id) ===
              String(2) &&
            this.customCategoryOffers.institution_id == null) ||
          (this.selectedOfferType == "customCategoryOffers" &&
            String(this.customCategoryOffers.booking_user_category_id) ===
              String(4) &&
            this.customCategoryOffers.institution_id == null) ||
          (this.selectedOfferType == "customCategoryOffers" &&
            this.customCategoryOffers.validate_doc_id == null)
        ) {
          console.log("lockinh here 4903");
          return;
        }
        if (
          (this.selectedOfferType == "bankOffer" &&
            this.bankOffer.bank_id == null) ||
          (this.selectedOfferType == "bankOffer" &&
            this.bankOffer.card_id == null)
        ) {
          console.log("lockinh here 4912");
          return;
        }
        if (
          (this.selectedOfferType == "promoCode" &&
            this.promoCode.booking_user_category_id == null) ||
          (this.selectedOfferType == "promoCode" &&
            this.promoCode.institution_id == null)
        ) {
          console.log("lockinh here 4921");
          return;
        }
        if (valid) {
          this.OfferConfiguraion["pvms_start_show_time"] = this
            .OfferConfiguraion["pvms_start_show_time"]
            ? moment(
                this.OfferConfiguraion["pvms_start_show_time"],
                "HH:mm"
              ).format("HH:mm:ss")
            : null;
          this.OfferConfiguraion["pvms_end_show_time"] = this.OfferConfiguraion[
            "pvms_end_show_time"
          ]
            ? moment(
                this.OfferConfiguraion["pvms_end_show_time"],
                "HH:mm"
              ).format("HH:mm:ss")
            : null;
          this.btenable = true;
          if (this.OfferConfiguraion.offer_applicable_on_all_cinemas === "Y") {
            this.selectedCinemaScreenSeatClassList.map(
              (item) =>
                (item.tt_id =
                  item.tt_id && item.tt_id.hasOwnProperty("tt_id")
                    ? item.tt_id.tt_id
                    : null)
            );
          }

          let payload = {
            os_id: os_id,
            ...this.OffersAndPromotion,
            ...this.RedemptionOutlet,
            weekDays: this.weekDays,
            ...this.OfferConfiguraion,
            CinemaScreenSeatClassList: this.selectedCinemaScreenSeatClassList,
            offerType: this.selectedOfferType,
            buyAndGetFreeTickets: this.buyAndGetFreeTickets,
            buyTicketFnbFixedPrice: this.buyTicketFnbFixedPrice,
            buyAndgetOffOnAnother: this.buyAndgetOffOnAnother,
            discountList: this.discountLists,
            buyAndGetCombo: this.buyAndGetCombo,
            customCategoryOffers: this.customCategoryOffers,
            bankOffer: this.bankOffer,
            promoCode: this.promoCode,
            OfferContent: this.offerContent,
            SignageContainer:this.signageContainer
          };
          MarketingService.UpdatePromotionAndOffers(payload)
            .then((response) => {
              this.btenable = false;
              const { data } = response;
              if (data && data.status) {
                // data.Records.length > 0
                this.$toasted.show(data.message || this.AdminError);
                this.$router.push({
                  path: "/marketing/promotions-and-offers",
                });
              } else {
                // Show Error Message
                this.$toasted.show(data.message || this.AdminError);
                // this.showError(data.message || this.AdminError);
              }
            })
            .catch(this._CatchError);
        } else {
          console.log("NOT VALID", valid);
        }
      });
      // }
    },
    addMoreCinemasScreenSeatClass: function () {
      this.selectedCinemaScreenSeatClassList.push({
        cine_id: null,
        screen_id: null,
        sst_id: null,
        tt_id: null,
      });
      this.CinemasScreenSeatClassdataList.push({
        cinemasList: this.cinemasList,
        screenList: [],
        seatClassList: [],
      });
    },
    removeCinemasScreenSeatClass: function (index) {
      this.selectedCinemaScreenSeatClassList.splice(index, 1);
      this.CinemasScreenSeatClassdataList.splice(index, 1);
    },
    addSignageData() {
      this.signageContainer.push({
        width: "",
        height: "",
        imageUrl: ""
      });
    },
    removeSignage(index) {
      this.signageContainer.splice(index, 1);
    },

    // Saif End
    addDiscount: function () {
      this.discountLists.push({
        oc_buy_no_of_ticket: "",
        oc_discount_value: "",
        oc_discount_value_is_percentage: "N",
        oc_max_discount_amount: null,
        canCombineOtherOffers: "N",
        selectedCombinedOffer: null,
      });
    },
    addMorePromo: function () {
      this.promoCode.promoCodeList.push({
        promo_code: null,
        pcs_no_of_transaction: null,
        pcs_min_ticket_amount: null,
        pcs_max_discount_amount: null,
        pcs_offer_value: null,
        pcs_offer_value_is_percentage: "N",
      });
    },
    removePromo: function (index) {
      this.promoCode.promoCodeList.splice(index, 1);
    },
    removeDiscount: function (index) {
      this.discountLists.splice(index, 1);
    },
    onChangeCustomerCategory: function () {
      this.customCategoryOffers.institution_id = null;
    },
    onChangeMultipleHandler: function (event) {
      if (event === "N") {
        this.promoCode.promoCodeList = this.promoCode.promoCodeList.slice(0, 1);
      }
    },
  },
};
</script>

<style>
.select-offers-list {
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}

.spanText {
  position: absolute;
  right: 15px;
  top: 10px;
  font-size: 10px !important;
}

.select-offers-list li {
  padding-top: 15px;
}

.select-offers-list li:not(:last-child) {
  padding-bottom: 15px;
  border-bottom: 1px solid #dee2e6;
}

.timepicker li,
.timepicker li .actived {
  list-style: none !important;
  padding-top: 0 !important;
  border-bottom: none !important;
}

.offer-title {
  display: flex;
}

.custom-date .btn-clearDate {
  right: 40px !important;
}
.new-border {
  border: 2px solid #b1b4b8;
}
label {
  color: black !important;
}
.internal-border-new {
  border: 1px solid #3876d2;
  /*background-color: #e6e6f8;*/
}
.internal-border {
  border: 1px solid #3876d2;
  background-color: #e6e6f8;
  display: flex;
  flex-wrap: wrap;
  border-radius: 10px;
  margin: 0 15px 15px 15px;
  padding-top: 15px;
}
.fs {
  font-size: 17px;
}
.back {
  background-color: #f5f5f5;
}
.mar {
  margin-left: 30px;
}
.back_white {
  background-color: white;
  border: 2px solid #b1b4b8;
  border-radius: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/MarketingContainer/PromotionsAndOffersComponent/editPromotionsAndOffers.vue